<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <Header />

    <div
     v-if="
                  idRecibo !== null && informacionSesion.idPaciente !== null
                "
      class="d-flex justify-content-center"
      style="width: 100%; height: 110vh"
    >

      <pago-realizado
                    :idRecibo="idRecibo"
                    :idPaciente="informacionSesion.idPaciente"
                    :idFactura="idFactura"
                    :etapaRecibo="etapaRecibo"
                    :informacionSesion="informacionSesion"
                    :idPti="idPTI"
                    @eliminarRecibo="eliminarRecibo"
                  ></pago-realizado>
    </div>

    <div v-else style="width: 100%;"> 
      <br />
      <div class="grid-contenido-central">
        <div class="justify-content-center">
          <b-card class="bCardGlobalXXL">
            <b-row>
              <b-col cols="1" v-if="idRecibo == null">
                <div style="padding-left: 60px; padding-top: 10px">
                  <b-button
                    variant="outline-primary"
                    pill
                    @click="regresarPantalla()"
                  >
                    <font-awesome-icon :icon="['fas', 'arrow-left']" />
                  </b-button>
                </div>
              </b-col>
              <b-col>
                <div class="divSubtitulo d-flex justify-content-between">
                  <p
                    class="textSubtitulo"
                    style="padding-left: 10px; font-size: large"
                  >
                    Caja Cobro
                  </p>
                  <p
                    class="textSubtituloCodigo"
                    style="padding-right: 10px; font-size: large"
                  >
                    CJ_01_COBRO SESION
                  </p>
                </div>
              </b-col>
            </b-row>
            <template
              v-if="
                !loaderPrincipal &&
                (renegociacionExitosa || listaDistibucion.length > 0) &&
                idRecibo == null &&
                existenTratamientosPTIReplica
              "
            >
              <wizzardCajav5
                v-if="idFlujoPti != null && idFlujoPti === 3 && idEtapa === 94"
                :idPaciente="informacionSesion.idPaciente"
                :activarEdicionAnfitrion="activarEdicionAnfitrion"
                @cambiarActivarEdicionAnfitrion="cambiarActivarEdicionAnfitrion"
              ></wizzardCajav5>
            </template>

            <div
              class="noAlTope"
              v-if="!activarEdicionAnfitrion && !loadRenegociar"
            >
              <b-row
                style="min-height: 35em"
                v-if="!distribuir && idRecibo == null"
              >
                <b-col cols="8">
                  <b-card class="bCardGlobalXL">
                    <b-row>
                      <b-col class="text-left">
                        <h3 v-if="!loaderInformacion">
                          <strong class="subcategoria"
                            >Información del pago</strong
                          >
                        </h3>
                        <h3 v-else>
                          <strong
                            >Obteniendo informacion del paciente...</strong
                          >
                        </h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-left">
                        <p class="datitos" style="padding-bottom: 5px">
                          <strong>Nombre:</strong>
                          <span class="datitos" style="padding-bottom: 5px">
                            {{ informacionSesion.paciente }}
                          </span>
                        </p>
                      </b-col>
                      <b-col class="text-left">
                        <p class="datitos" style="padding-bottom: 5px">
                          <strong>Clínica:</strong>
                          <span class="datitos" style="padding-bottom: 5px">
                            {{ informacionSesion.clinica }}
                          </span>
                        </p>
                      </b-col>
                      <b-col class="text-right">
                        <span class="datitos" style="padding-bottom: 5px">
                          <p v-if="saldofinal > 0" style="color: green">
                            <span class="datitos" style="color: green"
                              ><strong>Saldo actual: </strong></span
                            >
                            <span class="datitos" style="color: green"
                              ><strong>{{ saldofinal | moneda }}</strong></span
                            >
                            <span v-if="saldoBloqueado" style="color: red">
                              (Congelado)</span
                            >
                          </p>
                          <p v-else-if="saldofinal < 0" style="color: red">
                            <span class="datitos" style="color: red"
                              ><strong>Saldo actual: </strong></span
                            >
                            <span class="datitos" style="color: red"
                              ><strong>{{ saldofinal | moneda }}</strong></span
                            >
                            <span v-if="saldoBloqueado" style="color: red">
                              (Congelado)</span
                            >
                          </p>
                          <p v-else>
                            <span class="datitos"
                              ><strong>Saldo actual: </strong></span
                            >
                            <span class="datitos"
                              ><strong>{{ saldofinal | moneda }}</strong></span
                            >
                            <span v-if="saldoBloqueado" style="color: red">
                              (Congelado)</span
                            >
                          </p>
                        </span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-left">
                        <p class="datitos" style="padding-bottom: 5px">
                          <strong>ID paciente:</strong>
                          <span class="datitos" style="padding-bottom: 5px">
                            {{ informacionSesion.idPaciente }}
                          </span>
                        </p>
                      </b-col>
                      <b-col class="text-left">
                        <p class="datitos" style="padding-bottom: 5px">
                          <strong>Odontólogo:</strong>
                          <span class="datitos" style="padding-bottom: 5px">
                            {{ informacionSesion.doctor }}
                          </span>
                        </p>
                      </b-col>
                      <b-col class="text-right">
                        <span
                          v-if="vale != null"
                          class="datitos"
                          style="padding-bottom: 5px"
                        >
                          <p>
                            <span class="datitos"
                              ><strong
                                >Saldo de vale empresarial:
                              </strong></span
                            >
                            <span class="datitos" style="color: green"
                              ><strong>{{ vale | moneda }}</strong></span
                            >
                          </p>
                        </span>
                      </b-col>
                    </b-row>
                  </b-card>
                  <div style="padding-bottom: 1px"></div>
                  <b-card class="bCardGlobalXL" v-if="!distribuir">
                    <div class="text-left" v-if="!loaderInformacion">
                      <CajaSesionDetalle
                        :loaderPrincipal="loaderPrincipal"
                        :tratamientosSesion="tratamientosSesionPorPagar"
                        :listaDistibucion="listaDistibucionPorPagar"
                        :descuentoPorTratamiento="descuentoPorTratamiento"
                        :cuponSeleccionado="cuponSeleccionado"
                        @eliminarCupon="eliminarCupon"
                        title="Servicios a pagar"
                      />

                      <CajaSesionDetalle
                        :loaderPrincipal="loaderPrincipal"
                        :listaDistibucion="listaDistibucionPorProgramar"
                        :descuentoPorTratamiento="descuentoPorTratamiento"
                        :cuponSeleccionado="cuponSeleccionado"
                        @eliminarCupon="eliminarCupon"
                        title="Servicios a programar"
                      />
                    </div>
                  </b-card>
                </b-col>

                <b-col cols="4">
                  <div>
                    <div v-if="distribuir"></div>
                    <div v-else>
                      <div>
                        <b-card class="bCardGlobalXL" style="height: 100%">
                          <div class="text-left">
                            <h3 v-if="!loaderInformacion">
                              <strong class="subcategoria"
                                >Formas de pago</strong
                              >
                            </h3>
                            <template
                              v-if="
                                cuponSeleccionado.length > 0 &&
                                cuponSeleccionado[0].idTipoAplicacion == 2
                              "
                            >
                              <b-row>
                                <b-col>
                                  <p></p>
                                </b-col>
                              </b-row>
                            </template>
                            <template v-else>
                              <b-row>
                                <b-col class="text-left">
                                  <br />
                                  <p class="datosPago">Subtotal a pagar</p>
                                </b-col>
                                <b-col
                                  class="text-right"
                                  style="padding-right: 0"
                                >
                                  <br />
                                  <p>
                                    <strong>
                                      <span
                                        v-if="restante === 0"
                                        class="datosPago"
                                        style="color: #0069aa"
                                        >{{ Math.floor( totalOriginal ) | moneda }} </span
                                      >
                                      <span
                                        v-else
                                        class="datosPago"
                                        style="color: #0069aa"
                                        >{{ Math.floor( totalOriginal ) | moneda }} </span
                                      >
                                    </strong>
                                  </p>
                                </b-col>
                                <b-col cols="1" style="padding: 0"></b-col>
                              </b-row>
                            </template>

                            <template
                              v-if="
                                cuponActivo &&
                                cuponSeleccionado[0].idTipoAplicacion == 1 &&
                                cuponConHerramienta == false
                              "
                            >
                              <b-row
                                class="mb-0"
                                v-for="(items, index) in cuponSeleccionado"
                                :key="index + '-cupon'"
                              >
                                <b-col class="text-left">
                                  <p
                                    class="datosPago bold"
                                    style="
                                      color: var(--color-dentalia) !important;
                                    "
                                  >
                                    {{ items.codigo }} aplicado
                                  </p>
                                </b-col>
                                <b-col
                                  class="text-right"
                                  style="padding-right: 0"
                                >
                                  <p class="datosPago">
                                    <strong>
                                      <span style="color: #0069aa">{{
                                        totalCuponesM | moneda
                                      }}</span>
                                    </strong>
                                  </p>
                                </b-col>
                                <b-col
                                  class="text-left"
                                  cols="1"
                                  style="padding: 0"
                                >
                                  <b-button
                                    v-b-tooltip.hover.auto:title="
                                      'Quitar cupón'
                                    "
                                    size="sm"
                                    variant="ligth"
                                    @click="eliminarCupon(index)"
                                  >
                                    <b-icon-x-circle
                                      variant="danger"
                                    ></b-icon-x-circle>
                                  </b-button>
                                </b-col>
                              </b-row>
                            </template>

                            <b-row
                              class="mb-0"
                              v-if="
                                descuentoCupon != null &&
                                descuentoCupon > 0 &&
                                cuponConHerramienta === false
                              "
                            >
                              <b-col class="text-left">
                                <p class="datosPago">Descuento cupón</p>
                              </b-col>
                              <b-col
                                class="text-right"
                                style="padding-right: 0%"
                              >
                                <p class="datosPago">
                                  <strong>
                                    <span style="color: #0069aa"
                                      >-{{ descuentoCupon | moneda }}</span
                                    >
                                  </strong>
                                </p>
                              </b-col>
                              <b-col cols="1" style="padding: 0%"></b-col>
                            </b-row>
                            <b-row
                              class="mb-0"
                              v-if="
                                descuentoCupon != null &&
                                cuponConHerramienta == true
                              "
                            >
                              <b-col cols="5">
                                <div @click="boton()">
                                  <p class="datosPago">
                                    Descuento cupón
                                    <font-awesome-icon
                                      v-if="mostrar"
                                      :icon="['fas', 'arrow-up']"
                                    />
                                    <font-awesome-icon
                                      v-else
                                      :icon="['fas', 'arrow-down']"
                                    />
                                  </p>
                                </div>
                              </b-col>
                              <b-col
                                class="text-right"
                                style="padding-right: 0"
                              >
                                <p class="datosPago">
                                  <strong>
                                    <span style="color: #0069aa"
                                      >-{{ descuentoTotal | moneda }}</span
                                    >
                                  </strong>
                                </p>
                              </b-col>

                              <b-col
                                class="text-left"
                                cols="1"
                                style="padding: 0"
                              >
                                <b-button
                                  v-b-tooltip.hover.auto:title="'Quitar cupón'"
                                  size="sm"
                                  variant="ligth"
                                  @click="eliminarCupon(0)"
                                >
                                  <b-icon-x-circle
                                    variant="danger"
                                  ></b-icon-x-circle>
                                </b-button>
                              </b-col>
                            </b-row>
                            <b-card
                              class="txSesion"
                              v-if="
                                descuentoCupon != null &&
                                cuponConHerramienta == true &&
                                mostrar == true
                              "
                            >
                              <b-row class="mb-0" style="padding-top: 5px">
                                <b-col
                                  style="padding-right: 0%"
                                  v-show="mostrar"
                                >
                                  <b-row>
                                    <b-col cols="8"
                                      ><p class="text-left datosPago">
                                        Descuento especial
                                      </p></b-col
                                    >
                                    <b-col style="padding-right: 5px"
                                      ><p class="text-right datosPago">
                                        -{{ descuentoCupon | moneda }}
                                      </p></b-col
                                    >
                                    <b-col cols="1"></b-col>
                                  </b-row>
                                  <b-row style="padding-top: 3px">
                                    <b-col cols="8"
                                      ><p class="text-left datosPago">
                                        {{ cuponSeleccionado[0].codigo }}
                                      </p></b-col
                                    >
                                    <b-col
                                      v-if="
                                        cuponSeleccionado[0]
                                          .idTipoDescuentoCupon == 2 &&
                                        descuentoPorTratamiento.length == 0
                                      "
                                      style="padding-right: 5px"
                                      ><p class="text-right datosPago">
                                        -{{
                                          cuponSeleccionado[0].cantidadDescuento
                                            | moneda
                                        }}
                                      </p></b-col
                                    >
                                    <b-col
                                      v-else-if="
                                        cuponSeleccionado[0]
                                          .idTipoDescuentoCupon == 1 &&
                                        descuentoPorTratamiento.length == 0
                                      "
                                      style="padding-right: 5px"
                                      ><p class="text-right datosPago">
                                        -{{ totalCuponesM | moneda }}
                                      </p></b-col
                                    >
                                    <b-col
                                      v-else-if="
                                        descuentoPorTratamiento.length > 0
                                      "
                                      style="padding-right: 5px"
                                      ><p class="text-right datosPago">
                                        -{{ cuponesTratamiento | moneda }}
                                      </p></b-col
                                    >
                                    <b-col cols="1"></b-col>
                                  </b-row>
                                  <b-row style="padding-top: 3px">
                                    <b-col cols="8"
                                      ><p class="text-left datosPago">
                                        Total de descuento:
                                      </p></b-col
                                    >
                                    <b-col style="padding-right: 5px"
                                      ><p
                                        class="text-right datosPago bold"
                                        style="color: #0069aa"
                                      >
                                        -{{ descuentoTotal | moneda }}
                                      </p></b-col
                                    >
                                    <b-col cols="1"></b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </b-card>
                            <!--                    Costo Por financiamiento          -->
                            <b-row v-if="montoFinanciar !== 0">
                              <b-col class="text-left">
                                <br />
                                <p class="datosPago">
                                  Costo de financiamiento (IVA incluido)
                                </p>
                              </b-col>
                              <b-col
                                class="text-right"
                                style="padding-right: 0%"
                              >
                                <br />
                                <p>
                                  <strong>
                                    <span
                                      class="datosPago"
                                      style="color: #0069aa"
                                      >{{
                                        montoFinanciar | monedaDecimales
                                      }}</span
                                    >
                                  </strong>
                                </p>
                              </b-col>
                              <b-col cols="1" style="padding: 0%"></b-col>
                            </b-row>
                            <!--         Fin           Costo Por financiamiento          -->
                            <b-row>
                              <b-col class="text-left">
                                <br />
                                <p class="datosPago">Total a pagar</p>
                              </b-col>
                              <b-col
                                class="text-right"
                                style="padding-right: 0%"
                              >
                                <br />
                                <p>
                                  <strong>
                                    <span
                                      v-if="montoFinanciar !== 0"
                                      class="datosPago"
                                      style="color: #0069aa"
                                      >{{
                                        (totalFinalVista + montoFinanciar)
                                          | monedaDecimales
                                      }} </span
                                    >
                                    <span
                                      v-else-if="restante === 0"
                                      class="datosPago"
                                      style="color: #0069aa"
                                      >{{
                                        Math.floor(totalFinalVista) | moneda
                                      }}</span
                                    >
                                    <span
                                      v-else
                                      class="datosPago"
                                      style="color: #0069aa"
                                      >{{
                                        Math.floor(totalFinalVista) | moneda
                                      }}</span
                                    >
                                  </strong>
                                </p>
                              </b-col>
                              <b-col cols="1" style="padding: 0%"></b-col>
                            </b-row>
                            <b-row>
                              <b-col
                                cols="1"
                                v-if="
                                  cuponesDisponibles.length > 0 &&
                                  !fieldsDisabled
                                "
                              >
                                <b-button
                                  :disabled="fieldsDisabled"
                                  size="lg"
                                  variant="info"
                                  style="
                                    background-color: white;
                                    border-color: white;
                                  "
                                  class="pt-1 pl-2 pb-0"
                                  pill
                                  v-b-popover.hover.bottom="
                                    'Consulta los cupones disponibles del paciente'
                                  "
                                  @click="abrirModalCupon()"
                                  ><em class="cupon sm"></em
                                ></b-button>
                              </b-col>
                              <b-col
                                v-if="
                                  tratamientosCupon.length > 0 &&
                                  !fieldsDisabled
                                "
                              >
                                <b-form-input
                                  placeholder="Ingresa el código del cupón aquí"
                                  type="text"
                                  v-model="codigo"
                                  :disabled="fieldsDisabled"
                                  style="border-radius: 10px"
                                ></b-form-input>
                                <p v-if="mensaje != null" style="color: red">
                                  Error: {{ mensaje }}
                                </p>
                              </b-col>
                              <b-col
                                cols="4"
                                v-if="
                                  tratamientosCupon.length > 0 &&
                                  !fieldsDisabled
                                "
                              >
                                <b-button
                                  :disabled="fieldsDisabled || marketing"
                                  size="sm"
                                  variant="outline-info"
                                  pill
                                  @click="aplicarCuponMarketing()"
                                  >Aplicar cupón</b-button
                                >
                              </b-col>
                            </b-row>
                            <b-row class="mb-4">
                              <b-col cols="10"></b-col>
                              <b-col style="padding-left: 40px">
                                <b-button
                                  v-if="
                                    $localStorageService.can(
                                      'Bton_Agregar_pago'
                                    )
                                  "
                                  size="sm"
                                  variant="outline-primary"
                                  pill
                                  v-b-popover.hover.bottom="
                                    'Agregar métodos de pago'
                                  "
                                  @click="abrirModalPago(1)"
                                  ><font-awesome-icon :icon="['fas', 'plus']"
                                /></b-button>
                              </b-col>
                            </b-row>
                            <div style="min-height: 10em">
                              <b-card class="txSesion">
                                <div
                                  v-if="
                                    pagos.length > 0 || formaPagoCaja.length > 0
                                  "
                                >
                                  <b-row
                                    v-for="(p, i) in pagos"
                                    :key="'Pago' + i"
                                    style="
                                      padding-left: 3px;
                                      padding-top: 10px;
                                      padding-right: 5px;
                                    "
                                  >
                                    <b-col cols="6">
                                      <b-button
                                        v-b-tooltip.hover.auto:title="
                                          'Quitar pago'
                                        "
                                        size="sm"
                                        variant="ligth"
                                        @click="eliminarPago(p)"
                                      >
                                        <b-icon-x-circle
                                          variant="danger"
                                        ></b-icon-x-circle>
                                      </b-button>
                                      <span
                                        ><strong>{{
                                          p.formaPago.nombreForma
                                        }}</strong></span
                                      >
                                    </b-col>
                                    <b-col class="text-right" cols="6"
                                      ><span class="">{{
                                        p.monto | moneda
                                      }}</span></b-col
                                    >
                                  </b-row>
                                  <b-row
                                    v-for="(p, i) in formaPagoCaja"
                                    :key="'Pago' + i"
                                    style="
                                      padding-left: 3px;
                                      padding-top: 10px;
                                      padding-right: 5px;
                                    "
                                  >
                                    <b-col cols="6">
                                      <span v-if="p.idMetodoPago === 7">
                                        <strong> {{ p.financiera }} </strong>
                                        <span> Monto a financiar:</span>
                                        <p>
                                          ({{ p.plazoFinanciera }} pagos
                                          quincenales)
                                        </p>
                                      </span>
                                      <span
                                        v-else-if="
                                          p.formaPago.idFormaPago === formasPagoValidar.tdc &&
                                          p.idPagoPlazoFijo === null
                                        "
                                      >
                                        <div style="display: grid">
                                          <strong
                                            >{{ p.formaPago.nombreForma }}
                                            <span v-if="p.msi !== null">
                                              (Con Msi):
                                            </span>
                                          </strong>
                                          <span v-if="p.msi !== null">
                                            {{ p.msi }} pagos aprox de
                                            {{
                                              Math.ceil(p.monto / p.msi)
                                                | monedaSinDecimal
                                            }}
                                          </span>
                                        </div>
                                        <span
                                          v-if="
                                            p.formaPago.idFormaPago === formasPagoValidar.tdc &&
                                            p.pagoMensual !== null
                                          "
                                        >
                                          ( {{ p.msi }} pagos de aprox
                                          {{ p.pagoMensual | monedaEntero }} )
                                        </span>
                                      </span>
                                      <span v-else>
                                        <strong
                                          >{{ p.formaPago.nombreForma }}
                                        </strong>
                                        <span
                                          v-if="
                                            p.formaPago.idFormaPago === formasPagoValidar.tdc &&
                                            p.pagoMensual !== null
                                          "
                                        >
                                          ( {{ p.msi }} pagos de aprox
                                          {{ p.pagoMensual | monedaEntero }} )
                                        </span>
                                      </span>
                                    </b-col>
                                    <b-col class="text-right" cols="6">
                                      <b-button
                                        v-if="
                                          [2, 3, 4].includes(
                                            p.formaPago.idFormaPago
                                          ) && p.idBanco === null
                                        "
                                        v-b-tooltip.hover.auto:title="
                                          'Completar información de pago'
                                        "
                                        size="sm"
                                        variant="ligth"
                                        @click="editarPagoDribucion(p, i)"
                                      >
                                        <b-icon-exclamation-circle
                                          style="color: darkorange"
                                        ></b-icon-exclamation-circle>
                                      </b-button>

                                      <span
                                        style="color: #3f9bd3; font-weight: 500"
                                        v-if="p.idDetallePagoPlazoFijo !== null"
                                        >{{ p.monto | monedaDecimales }}</span
                                      >
                                      <span
                                        style="color: #3f9bd3; font-weight: 500"
                                        v-else
                                        >{{ p.monto | moneda }}</span
                                      >
                                    </b-col>
                                  </b-row>
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                </div>
                                <div v-else>
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <p style="text-align: center">
                                    Aun no hay métodos de pago
                                  </p>
                                  <p style="text-align: center">agregados</p>
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                </div>
                              </b-card>
                            </div>
                            <br />
                            <b-row v-if="pagosFinal == 0">
                              <b-col class="text-left">
                                <p class="datosPago">Total pagado</p>
                              </b-col>
                              <b-col class="text-right">
                                <p>
                                  <span class="datosPago">
                                    {{ pagosFinal | moneda }}</span
                                  >
                                </p>
                              </b-col>
                            </b-row>
                            <b-row style="font-size: small">
                              <b-col class="text-left">
                                <p class="datosPago">Restante</p>
                              </b-col>
                              <b-col class="text-right">
                                <p>
                                  <span class="datosPago">
                                    {{ restanteFinal | moneda }}</span
                                  >
                                </p>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col class="text-left">
                                <p class="datosPago">Total para abono</p>
                              </b-col>
                              <b-col class="text-right">
                                <p>
                                  <span class="datosPago">
                                    {{ abonoSaldoFinal | moneda }}</span
                                  >
                                </p>
                              </b-col>
                            </b-row>
                          </div>
                          <div style="margin-top: auto" class="text-center">
                            <b-button
                              v-if="
                                $localStorageService.can(
                                  'Bton_Agregar_cobrar'
                                ) && !realizandoPago
                              "
                              :disabled="
                                (pagos.length === 0 &&
                                  pagosDistibucion.length === 0 &&
                                  !cubreSaldo) ||
                                emepezarPago
                              "
                              pill
                              variant="primary"
                              @click="cobrar()"
                              >Cobrar
                            </b-button>
                            <b-progress
                              v-if="realizandoPago"
                              :max="100"
                              height="2rem"
                              :variant="progresBar.variant"
                            >
                              <b-progress-bar
                                height="2rem"
                                :value="progresBar.progreso"
                              >
                                <span>Procesando Su Pago....</span>
                              </b-progress-bar>
                            </b-progress>
                          </div>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div v-if="distribuir">
                <b-card class="bCardGlobalXL">
                  <b-row>
                    <b-col class="text-left">
                      <h3 v-if="!loaderInformacion">
                        <strong class="subcategoria"
                          >Información del pago</strong
                        >
                      </h3>
                      <h3 v-else>
                        <strong>Obteniendo informacion del paciente...</strong>
                      </h3>
                    </b-col>
                    <b-col class="text-right">
                      <h3 v-if="saldofinal > 0" style="color: green">
                        <span class="datitos"
                          ><strong>Saldo actual: </strong></span
                        >
                        <span class="datitos"
                          ><strong>{{ saldofinal | moneda }}</strong></span
                        >
                      </h3>
                      <h3 v-else-if="saldofinal < 0" style="color: red">
                        <span class="datitos"
                          ><strong>Saldo actual: </strong></span
                        >
                        <span class="datitos"
                          ><strong>{{ saldofinal | moneda }}</strong></span
                        >
                      </h3>
                      <h3 v-else>
                        <span class="datitos"
                          ><strong>Saldo actual: </strong></span
                        >
                        <span class="datitos"
                          ><strong>{{ saldofinal | moneda }}</strong></span
                        >
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-left">
                      <p class="datitos">
                        <strong>Nombre:</strong>
                        {{ informacionSesion.paciente }}
                      </p>
                      <p class="datitos">
                        <strong>ID paciente:</strong>
                        {{ informacionSesion.idPaciente }}
                      </p>
                      <p class="datitos">
                        <strong>Clínica:</strong>
                        {{ informacionSesion.clinica }}
                      </p>
                      <p class="datitos">
                        <strong>Odontólogo:</strong>
                        {{ informacionSesion.doctor }}
                      </p>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card class="bCardGlobalXL" style="height: 100%">
                  <div style="text-align: left">
                    <h3 v-if="!loaderInformacion">
                      <strong class="subcategoria"
                        >Distribución de abono de saldo</strong
                      >
                    </h3>
                  </div>
                  <div class="row">
                    <div class="col-12 text-right">
                      <p>Monto a distribuir: {{ totolaAbonar | moneda }}</p>
                      <p>Monto distribuido: {{ totalDistribuido | moneda }}</p>
                      <p>
                        monto por distribuir :
                        {{ (totolaAbonar - totalDistribuido) | moneda }}
                      </p>
                    </div>
                  </div>
                  <b-card
                    class="txSesion"
                    v-for="(tx, i) in listaTratamientosSinRealizar"
                    :key="'txAbono' + i"
                  >
                    <b-row>
                      <b-col class="text-left" cols="6">
                        <p class="datitos">
                          <strong
                            >{{ tx.nombreTratamiento }}
                            <span style="font-size: small"
                              >({{ tx.numeroSesionText }})</span
                            ></strong
                          >
                        </p>
                        <p class="datitos">ID: {{ tx.idTratamiento }}</p>
                        <p v-if="tx.numeroDiente != null" class="datitos">
                          Diente: {{ tx.numeroDiente }}
                        </p>
                      </b-col>
                      <b-col class="text-right" cols="2">
                        <p class="datitos" style="padding-top: 8px">
                          Precio: {{ tx.precioSesion | moneda }}
                        </p>
                        <p class="datitos" style="padding-top: 8px">
                          Saldo Actual : {{ tx.saldoFavor | moneda }}
                        </p>
                        <p class="datitos" style="padding-top: 8px">
                          <strong>Total: {{ tx.subTotal | moneda }}</strong>
                        </p>
                      </b-col>
                      <b-col cols="2">
                        <div v-if="!tx.editar">
                          {{ tx.abono | moneda }}
                          <b-button
                            v-b-tooltip.hover.auto:title="'Editar Abono'"
                            size="sm"
                            variant="ligth"
                            @click="tx.editar = !tx.editar"
                          >
                            <b-icon-pen variant="primary"></b-icon-pen>
                          </b-button>
                          <b-button
                            v-b-tooltip.hover.auto:title="'Quitar pago'"
                            v-if="tx.abono > 0"
                            size="sm"
                            variant="ligth"
                            @click="quitarAbono(tx)"
                          >
                            <b-icon-x-circle variant="danger"></b-icon-x-circle>
                          </b-button>
                        </div>
                        <div
                          v-if="tx.editar"
                          style="display: flex"
                          onpaste="return false"
                        >
                          <b-form-input
                            class="w-50"
                            @input="editarAbono()"
                            @keypress="onlyNumber"
                            :disabled="
                              (parseFloat(totalDistribuido) ===
                                parseFloat(totolaAbonar) &&
                                (tx.abono === '' ||
                                  parseFloat(tx.abono) <= 0)) ||
                              tx.precioSesion === tx.saldoFavor
                            "
                            type="number"
                            :min="0"
                            v-model="tx.abono"
                          ></b-form-input>
                          <b-button
                            v-b-tooltip.hover.auto:title="'Aplicar'"
                            size="sm"
                            variant="ligth"
                            @click="tx.editar = !tx.editar"
                          >
                            <b-icon-check-circle
                              variant="success"
                            ></b-icon-check-circle>
                          </b-button>
                        </div>
                      </b-col>
                      <b-col class="text-right" cols="2">
                        <h5 style="color: #0069aa">
                          <span class="datitos">Saldo Final: </span>
                          <strong>{{
                            (tx.saldoFavor +
                              (tx.abono === "" ? 0 : parseFloat(tx.abono)))
                              | moneda
                          }}</strong>
                        </h5>
                      </b-col>
                    </b-row>
                  </b-card>
                  <div class="text-right">
                    <p class="datitos">
                      Nota: el saldo no distribuido será asignado al abono de
                      saldo general
                    </p>
                  </div>
                </b-card>
                <br />
                <b-row>
                  <b-col cols="4"></b-col>
                  <b-col cols="1" style="text-align: center">
                    <b-button
                      v-if="!realizandoPago"
                      block
                      pill
                      size="m"
                      variant="primary"
                      @click="cobrar()"
                      >Cobrar
                    </b-button>

                    <b-progress
                      v-if="realizandoPago"
                      :max="100"
                      height="2rem"
                      :variant="progresBar.variant"
                    >
                      <b-progress-bar
                        height="2rem"
                        :value="progresBar.progreso"
                      >
                        <span>Procesando Su Pago....</span>
                      </b-progress-bar>
                    </b-progress>
                  </b-col>
                  <b-col cols="2"></b-col>
                  <b-col cols="1" style="text-align: center">
                    <b-button
                      v-if="!realizandoPago"
                      block
                      pill
                      size="m"
                      variant="secondary"
                      @click="
                        distribuir = false;
                        emepezarPago = false;
                      "
                      >Cancelar
                    </b-button>
                  </b-col>
                  <b-col cols="4"></b-col>
                </b-row>
              </div>
              <div
                v-if="
                  idRecibo !== null && informacionSesion.idPaciente !== null
                "
              >
                <b-card class="bCardGlobalXL">
                  <b-row>
                    <b-col class="text-left">
                      <h3 v-if="!loaderInformacion">
                        <strong class="subcategoria"
                          >Información del pago</strong
                        >
                      </h3>
                      <h3 v-else>
                        <strong>Obteniendo informacion del paciente...</strong>
                      </h3>
                    </b-col>
                    <b-col class="text-right">
                      <h3 v-if="saldofinal > 0" style="color: green">
                        <span class="datitos"
                          ><strong>Saldo actual: </strong></span
                        >
                        <span class="datitos"
                          ><strong>{{ saldofinal | moneda }}</strong></span
                        >
                      </h3>
                      <h3 v-else-if="saldofinal < 0" style="color: red">
                        <span class="datitos"
                          ><strong>Saldo actual: </strong></span
                        >
                        <span class="datitos"
                          ><strong>{{ saldofinal | moneda }}</strong></span
                        >
                      </h3>
                      <h3 v-else>
                        <span class="datitos"
                          ><strong>Saldo actual: </strong></span
                        >
                        <span class="datitos"
                          ><strong>{{ saldofinal | moneda }}</strong></span
                        >
                      </h3>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="text-left">
                      <p class="datitos">
                        <strong>Nombre:</strong>
                        {{ informacionSesion.paciente }}
                      </p>
                      <p class="datitos">
                        <strong>ID paciente:</strong>
                        {{ informacionSesion.idPaciente }}
                      </p>
                      <p class="datitos">
                        <strong>Clínica:</strong>
                        {{ informacionSesion.clinica }}
                      </p>
                      <p class="datitos">
                        <strong>Odontólogo:</strong>
                        {{ informacionSesion.doctor }}
                      </p>
                    </b-col>
                  </b-row>
                </b-card>
                <div>
                
                  <pago-realizado
                    :idRecibo="idRecibo"
                    :idPaciente="informacionSesion.idPaciente"
                    :idFactura="idFactura"
                    :etapaRecibo="etapaRecibo"
                    :montoFinanciar="montoFinanciar"
                    :totalFinalVista="totalFinalVista"
                    @eliminarRecibo="eliminarRecibo"
                  ></pago-realizado>
                </div>
              </div>

              <b-row>
                <div
                  style="text-align: center; width: 100%"
                  v-if="
                    $localStorageService.can('Bton_M2_caja_correc_pago') &&
                    idEtapa === 94
                  "
                >
                  <b-button
                    size="sm"
                    v-if="
                      !loaderPrincipal &&
                      listaDistibucion.length > 0 &&
                      idRecibo === null &&
                      existenTratamientosPTIReplica
                    "
                    :disabled="realizandoPago"
                    variant="outline-success"
                    @click="preguntarCorrecionPTI()"
                    >Corrección de pago PTI
                  </b-button>
                </div>
              </b-row>
            </div>
          </b-card>
        </div>
      </div>
    </div>

    <!--  Aqui van los modales   -->

    <b-modal
      v-model="modalPago"
      no-close-on-backdrop
      centered
      size="lg"
      hide-header
      hide-footer
    >
      <form v-if="modalPago">
        <em class="tarjeta" style="width: 2%"></em>
        <span
          v-if="pago.idFormaPagoTemporal != null"
          class="textSize ml-2"
          style="font-weight: 600; color: #044169"
        >
          Completar información de pago
        </span>
        <span
          v-else
          class="textSize ml-2"
          style="font-weight: 600; color: #044169"
        >
          Agregar Nuevo Pago
        </span>

        <div class="m-4">
          <b-row>
            <b-col v-if="$v.pago.monto.$params.required !== undefined">
              <span style="font-size: 12px; font-weight: 500"> Monto </span>
              <b-input-group style="width: 90%">
                <b-form-input
                  placeholder="$ Monto"
                  pattern="[0-9]{1,}"
                  type="number"
                  min="0"
                  v-model="$v.pago.monto.$model"
                  :state="validateState('monto')"
                  required
                  @input="obtenerMeses"
                  :disabled="
                    this.pago.idFormaPagoTemporal != null || bloquearMonto
                  "
                  style="border-radius: 10px"
                  @keydown="filterJustNumber($event)"
                ></b-form-input>
              </b-input-group>
              <div class="text-right" style="margin-top: -30px">
                <em
                  v-if="bloquearMonto"
                  class="editarV5"
                  style="width: 24px"
                  @click="reestablecerMontos()"
                  v-b-tooltip.hover.auto:title="'Editar Montos'"
                ></em>
              </div>
            </b-col>
            <b-col v-if="$v.pago.formaPago.$params.required !== undefined">
              <span style="font-size: 12px; font-weight: 500">
                Método de pago
              </span>
              <v-select
                placeholder="Selecciona el método de pago"
                v-model="$v.pago.formaPago.$model"
                :class="selectClass('formaPago')"
                :state="validateState('formaPago')"
                @input="limpiarCampos()"
                :options="
                  formasFiltro
                    .filter((f) => {
                      return (
                        !this.saldoBloqueado ||
                        (this.saldoBloqueado && f.idFormaPago !== formasPagoValidar.aplicarSaldo)
                      );
                    })
                    .filter((f) => {
                      return pago.monto > 0 || f.idFormaPago === formasPagoValidar.efectivo;
                    })
                    .filter((f) => {
                      return (
                        f.idFormaPago !== formasPagoValidar.aplicarSaldo ||
                        (informacionSesion.saldo > 0 && restante > 0)
                      );
                    })
                "
                label="nombreForma"
                :required="pago.formaPago == null"
                :disabled="
                  this.pago.idFormaPagoTemporal != null || bloquearMonto
                "
                :filterable="false"
                @search="filtroFormas"
              />
            </b-col>
          </b-row>

          <div
            class="row"
            v-if="pago.formaPago !== null && pago.formaPago.idFormaPago === formasPagoValidar.tdc"
          >
            <div class="col-6 mt-4">
              <b-form-radio-group
                id="pago"
                v-model="tipoPago"
                @input="cambiarTipoPago(tipoPago)"
                name="pago"
                :disabled="pago.idFormaPagoTemporal != null"
              >
                <b-form-radio :value="1">Contado</b-form-radio>
                <b-form-radio :value="2">Planes de pago</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>

          <div class="row">
            <div
              class="col-6 mt-4"
              v-if="$v.pago.financiera.$params.required !== undefined"
            >
              <span style="font-size: 12px; font-weight: 500">
                Financieras
              </span>
              <v-select
                placeholder="Financieras"
                v-model="$v.pago.financiera.$model"
                :class="selectClass('financiera')"
                :state="validateState('financiera')"
                :reduce="(fin) => fin.idFinanciera"
                :options="financierasFiltro"
                @input="obtenerMinimoFinanciera"
                label="financiera"
                variant="solo"
                :filterable="false"
                @search="filtroFinancieras"
              />
            </div>

            <div
              class="col-6 mt-4"
              v-if="
                $v.pago.msi.$params.required !== undefined &&
                (pago.tipoPago === 2 ||
                  (pago.formaPago !== null && pago.formaPago.idFormaPago === formasPagoValidar.financiamiento))
              "
            >
              <span style="font-size: 12px; font-weight: 500"> MSI </span>
              <v-select
                v-model="$v.pago.msi.$model"
                :state="validateState('msi')"
                maxLength="2"
                :options="msis"
                :reduce="(msi) => msi"
                placeholder="MSI"
                :disabled="!booleanMsi"
                @input="filtarBancoTerminal()"
                ><span slot="no-options"
                  >No hay plazos disponibles, selecciona otra opción</span
                >
              </v-select>
            </div>

            <div
              class="col-6 mt-4"
              v-if="$v.pago.idBanco.$params.required !== undefined"
            >
              <span style="font-size: 12px; font-weight: 500" v-if="
                  pago.formaPago !== null &&
                  pago.formaPago.idFormaPago !== formasPagoValidar.tdc &&
                  pago.formaPago.idFormaPago !== formasPagoValidar.tdd
                ">
                Banco
              </span>
              <span style="font-size: 12px; font-weight: 500" v-else>
                Terminal
              </span>
              <v-select
                v-if="
                  pago.formaPago !== null &&
                  pago.formaPago.idFormaPago !== formasPagoValidar.tdc &&
                  pago.formaPago.idFormaPago !== formasPagoValidar.tdd
                "
                placeholder="Banco"
                v-model="$v.pago.idBanco.$model"
                :class="selectClass('idBanco')"
                :state="validateState('idBanco')"
                :options="
                  pago.idFormaPagoTemporal !== null && pago.msi !== null
                    ? bancosClinicaPlazoFijo
                    : formasConBancosTerminalesFiltro
                "
                label="nombreBanco"
                :disabled="false"
                :filterable="false"
                @search="filtroBancos"
                variant="solo"
              >
              </v-select>
              <v-select
                v-else
                placeholder="Terminal"
                v-model="$v.pago.idBanco.$model"
                :class="selectClass('idBanco')"
                :state="validateState('idBanco')"
                :options="
                  pago.idFormaPagoTemporal !== null && pago.msi !== null
                    ? bancosClinicaPlazoFijo
                    : formasConBancosTerminalesFiltro
                "
                label="nombreBanco"
                :disabled="pago.msi === null && pago.tipoPago == 2"
                :filterable="false"
                @search="filtroBancos"
                variant="solo"
              >
              </v-select>
            </div>

            <div
              class="col-6 mt-4"
              v-if="$v.pago.referencia.$params.required !== undefined"
            >
              <span style="font-size: 12px; font-weight: 500">
                Referencia de pago
              </span>
              <b-form-input
                v-model="$v.pago.referencia.$model"
                :state="validateState('referencia')"
                placeholder="Referencia"
                :disabled="false"
                style="border-radius: 10px"
              >
              </b-form-input>
              <span style="font-size: 12px; font-weight: 500; color: red">
                Ingresa la referencia del pago del ticket de la terminal
              </span>
            </div>

            <div
              class="col-6 mt-4"
              v-if="$v.pago.numeroTarjeta.$params.required !== undefined"
            >
              <span style="font-size: 12px; font-weight: 500">
                Últimos 4 dígitos de la tarjeta
              </span>
              <b-form-group>
                <b-form-input
                  v-model="$v.pago.numeroTarjeta.$model"
                  :state="validateState('numeroTarjeta')"
                  pattern="[0-9]{1,}"
                  maxLength="4"
                  placeholder="****-****-****-1234"
                  :disabled="false"
                  style="border-radius: 10px"
                >
                </b-form-input>
              </b-form-group>
            </div>
          </div>
        </div>

        <div style="padding-top: 100px">
          <b-row>
            <b-col>
              <b-button
                pill
                class="float-right"
                v-if="this.pago.idFormaPagoTemporal != null"
                variant="success"
                @click="modificarPago()"
              >
                <span>Modificar</span>
              </b-button>
              <b-button
                v-else
                pill
                class="float-right"
                variant="primary"
                @click="agregarPago()"
              >
                <span>Agregar</span>
              </b-button>
            </b-col>
            <b-col cols="1"></b-col>
            <b-col>
              <b-button pill variant="secondary" @click="cerrarModal()"
                >Cancelar
              </b-button>
            </b-col>
          </b-row>
        </div>
      </form>
    </b-modal>

    <b-modal
      v-model="mostrarModalCorregirPTI"
      title=""
      centered
      hide-header
      hide-footer
    >
      <b-container fluid>
        <b-row>
          <b-col style="text-align: center" cols="12">
            <em class="group243 lg"></em>
            <div class="mt-2 col-md-12"></div>
          </b-col>
          <b-col style="text-align: center; font-weight: bold" cols="12">
            La corrección del pago la realiza:
          </b-col>
          <b-col style="text-align: center" cols="12">
            <div class="mt-4 col-md-12">
              <span style="font-size: 11px"
                >Se perderá la configuración de plazos. Deberá de ingresarla
                nuevamente.</span
              >
            </div>
          </b-col>

          <b-col
            style="text-align: center; margin-top: 2%"
            cols="4"
            v-if="
              $localStorageService.can('Bton_M2_caja_anfit') && !loadRenegociar
            "
          >
            <b-button
              :disabled="loadRenegociar"
              style="background-color: #1b81af"
              size="sm"
              pill
              @click="renegociarPTI(true)"
            >
              Anfitrión
            </b-button>
          </b-col>

          <b-col
            style="text-align: center; margin-top: 2%"
            cols="4"
            v-if="
              $localStorageService.can('Bton_M2_caja_canc') && !loadRenegociar
            "
          >
            <b-button
              :disabled="loadRenegociar"
              style="background-color: #1b81af"
              size="sm"
              pill
              @click="renegociarPTI(false)"
            >
              Embajador
            </b-button>
          </b-col>

          <b-col
            style="text-align: center; margin-top: 2%"
            cols="4"
            v-if="
              $localStorageService.can('Bton_M2_caja_EE') && !loadRenegociar
            "
          >
            <b-button
              :disabled="loadRenegociar"
              style="background-color: #595959"
              size="sm"
              pill
              @click="cancelarRenegociarPTI"
            >
              Cancelar
            </b-button>
          </b-col>
        </b-row>

        <b-row v-if="loadRenegociar">
          <b-col style="text-align: center">
            <b-spinner small></b-spinner>&nbsp;Espere un momento...
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      v-model="modalCupon"
      title=""
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
      <form v-if="modalCupon">
        <h4>
          <strong class="subcategoria" style="padding-left: 10px"
            >Cupones disponibles</strong
          >
        </h4>
        <b-card class="txSesion">
          <b-row>
            <b-col sm="12" md="12" lg="12">
              <div>
                <b-table
                  responsive
                  :items="cuponesDisponibles"
                  :fields="fields"
                  style="text-align: center"
                >
                  <template v-slot:cell(cantidadDescuento)="row">
                    <template v-if="row.item.idTipoDescuentoCupon == 2">
                      <span>{{ row.item.cantidadDescuento | moneda }}</span>
                    </template>
                    <template v-else>
                      <span>{{ row.item.cantidadDescuento }}%</span>
                    </template>
                  </template>
                  <template v-slot:cell(Acciones)="row">
                    <b-button-group>
                      <b-button
                        v-if="
                          row.item.seleccionado == false &&
                          fieldsDisabled == false &&
                          cuponSeleccionado.length == 0
                        "
                        title="Seleccionar"
                        variant="outline-primary"
                        size="sm"
                        pill
                        style="text-align: center"
                        @click="seleccionar(row.item)"
                        ><p>Seleccionar</p></b-button
                      >
                      <b-button
                        v-else-if="row.item.seleccionado == true"
                        title="Seleccionado"
                        variant="outline-info"
                        size="sm"
                        pill
                        style="text-align: center"
                        disabled
                      >
                        <p>Seleccionado</p>
                      </b-button>
                      <b-button
                        v-else-if="
                          row.item.seleccionado == false &&
                          fieldsDisabled == false &&
                          cuponSeleccionado.length > 0 &&
                          row.item.otraPromo == true
                        "
                        title="Seleccionar"
                        variant="outline-primary"
                        size="sm"
                        pill
                        style="text-align: center"
                        @click="seleccionar(row.item)"
                        ><p>Seleccionar</p></b-button
                      >
                      <b-button
                        v-else
                        title="Seleccionar"
                        variant="outline-primary"
                        size="sm"
                        pill
                        style="text-align: center"
                        @click="seleccionar(row.item)"
                        disabled
                        ><p>Seleccionar</p></b-button
                      >
                    </b-button-group>
                  </template>
                  <template v-slot:cell(otraPromo)="row">
                    <template v-if="row.item.otraPromo">
                      <span>Si</span>
                    </template>
                    <template v-else>
                      <span>No</span>
                    </template>
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
          <br />
          <br />
        </b-card>
      </form>
      <br />
      <div>
        <b-row>
          <b-col>
            <b-button
              pill
              size="sm"
              class="float-right"
              variant="primary"
              @click="aplicarCupon()"
            >
              <span>Aplicar</span>
            </b-button>
          </b-col>
          <b-col>
            <b-button
              pill
              size="sm"
              variant="secondary"
              @click="cerrarModalCupon()"
              >Cerrar
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      ref="validadorTrtsActivos"
      size="md"
    >
      <validador-tratamientos-caja
        :tratamientosInactivos="this.tratamientosInactivos"
        :dineroDistribuido="dineroDistribuido"
        :idSolicitud="idSolicitud"
        @cerrarModalTratsActivos="cerrarModalTratsActivos"
        :totalTratamientosActivos="totalTratamientosActivos"
        :idPti="idPTI"
        :tratamientosDePti="tratamientosDePti"
        :idEtapa="idEtapa"
      />
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {maxLength, numeric, required} from "vuelidate/lib/validators";
import {FormaPagoService} from "@/apiServices/formaPago/FormaPagoService";
import wizzardCajav5 from "@/views/cajaSesion/wizzardCajav5";
import {CuponesService} from "../../apiServices/cupones/CuponesService";
import {NuevoM2Service} from "@/apiServices/pti/NuevoM2Service";
import CajaSesionDetalle from "@/views/cajaSesion/cajaSesionV2Detalle";
import ValidadorTratamientosCaja from "@/components/caja/validadorTratamientosCaja.vue";
import PagoRealizado from "./pagoRealizado.vue";
import {formasPago} from '../../constantes/FormasPago';

export default {
  name: "cajaSesion",
  components: {
    ValidadorTratamientosCaja,
    CajaSesionDetalle,
    PagoRealizado,
    Header,
    wizzardCajav5,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      cuponesService: new CuponesService(),
      nuevoM2Service: new NuevoM2Service(),
      datosTabla: [],
      fields: [
        { key: "codigo", label: "ID cupón" },
        { key: "motivo", label: "Motivo de cupón" },
        { key: "cantidadDescuento", label: "Monto de cupón" },
        { key: "fechaExpedicion", label: "Fecha de expedición" },
        { key: "otraPromo", label: "Aplica con otros cupones" },
        "Acciones",
      ],
      existenTratamientosPTIReplica: false,
      finalizoCargaInicial: {
        finalizado: false,
        fin: [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
      },

      renegociacionExitosa: false,
      loadRenegociar: false,
      mostrarModalCorregirPTI: false,
      activarEdicionAnfitrion: false,

      formaPagoService: new FormaPagoService(),
      idSesion: null,
      idRecibo: null,
      idFactura: null,

      tratamientosSesion: [],
      total: 0,
      subtotal: 0,
      descuento: 0,
      saldoTrtamientos: 0,
      saldofinal: 0,
      abonoSaldo: 0,
      totalPagado: 0,
      restante: 0,

      totolaAbonar: 0,
      totalDistribuido: 0,
      totolaRestanteDistribuir: 0,
      distribuir: false,
      etapaRecibo: false,

      pagos: [],
      pago: this.newPago(),
      totalOriginal: null,
      modalPago: false,
      modalCupon: false,
      cuponActivo: false,
      cuponConHerramienta: false,
      mostrar: false,
      cuponesDisponibles: [],
      cuponValor: null,
      nombreCupon: null,
      codigo: null,
      mensaje: null,
      cuponMarketing: false,
      marketing: true,
      cuponSeleccionado: [],
      totalCupones: null,
      fieldsDisabled: false,
      arregloCupones: [],
      cuponAplicado: false,
      descuentoCupon: null,
      tratamientosCupon: [],
      descuentoPorTratamiento: [],
      numSesiones: null,
      listIdTrt: [],
      vale: null,

      formas: [],
      formaPagoCaja: [],
      formasFiltro: [],
      financieras: [],
      financierasFiltro: [],
      formasConBancosTerminales: [],
      formasConBancosTerminalesFiltro: [],
      bancosClinicaPlazoFijo: [],
      bancosPlazoFijo: [],
      msis: [],
      realizandoPago: false,
      emepezarPago: false,
      progresBar: {
        variant: "success",
        progreso: 0,
        progresoFinalizado: true,
      },

      informacionSesion: {
        idPaciente: null,
        paciente: "",
        clinica: "",
        doctor: "",
        saldo: 0,
        especialidades: "",
      },

      listaTratamientosSinRealizar: [],

      loaderPrincipal: false,
      loaderInformacion: false,
      cubreSaldo: false,

      listaDistibucion: [],
      pagosDesglosados: [],
      pagosDistibucion: [],
      pagoSeleccionado: null,
      montoMinimoFinanciera: 0,
      booleanMsi: false,
      hcLlenaPaciente: false,
      saldoBloqueado: false,

      idPTI: null,
      idFlujoPti: null,
      idEtapa: null,

      listaTratamientosLimpia: [],
      montoFinanciar: 0,

      tipoPago: 1,
      configuracionesMsi: [],
      bloquearMonto: false,
      registroActivo: null,
      idSolicitud: null,
      tratamientosInactivos: [],
      dineroDistribuido: 0,
      totalTratamientosActivos: 0,
      tratamientosDePti: true,
      timerId: null,

      formasPagoValidar:{
        efectivo: formasPago.EFECTIVO,
        tdc: formasPago.TDC,
        tdd: formasPago.TDD,
        transferencia: formasPago.TRANSFERENCIA,
        mercadoPago: formasPago.MERCADOPAGO,
        aplicarSaldo: formasPago.APLICARSALDO,
        financiamiento: formasPago.FINANCIAMIENTO,
      },
    };
  },
  validations() {
    if (this.pago.formaPago !== null) {
      if (this.pago.formaPago.idFormaPago === this.formasPagoValidar.tdc) {
        return {
          pago: {
            monto: { required },
            formaPago: { required },
            referencia: { required },
            financiera: {},
            idBanco: { required },
            numeroTarjeta: { required, numeric, maxLength: maxLength(4) },
            msi: { required, numeric },
          },
        };
      } else if (this.pago.formaPago.idFormaPago === this.formasPagoValidar.tdd) {
        return {
          pago: {
            monto: { required, numeric },
            formaPago: { required },
            referencia: { required },
            financiera: {},
            idBanco: { required },
            numeroTarjeta: { required, numeric, maxLength: maxLength(4) },
            msi: {},
          },
        };
      } else if (this.pago.formaPago.idFormaPago === this.formasPagoValidar.transferencia) {
        return {
          pago: {
            monto: { required, numeric },
            formaPago: { required },
            referencia: { required },
            financiera: {},
            idBanco: { required },
            numeroTarjeta: {},
            msi: {},
          },
        };
      } else if (this.pago.formaPago.idFormaPago === this.formasPagoValidar.financiamiento) {
        return {
          pago: {
            monto: { required, numeric },
            formaPago: { required },
            financiera: { required },
            referencia: {},
            idBanco: {},
            numeroTarjeta: {},
            msi: { required },
          },
        };
      } else {
        return {
          pago: {
            monto: { required, numeric },
            formaPago: { required },
            referencia: {},
            financiera: {},
            idBanco: {},
            numeroTarjeta: {},
            msi: {},
          },
        };
      }
    } else {
      return {
        pago: {
          monto: { required, numeric },
          formaPago: { required },
          referencia: {},
          financiera: {},
          idBanco: {},
          numeroTarjeta: {},
          msi: {},
        },
      };
    }
  },
  beforeDestroy() {
    if (this.timerId) clearTimeout(this.timerId);
  },
  beforeRouteLeave(to, from, next) {
    this.desbloquearSesion();
    next();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idSesion = this.$route.params.idSesion;
    this.obtenerInformacionSesion();
    this.validarPago();
  },
  computed: {
    tratamientosSesionPorPagar() {
      return this.tratamientosSesion;
    },
    tratamientosSesionPorProgramar() {
      return this.tratamientosSesion;
    },
    listaDistibucionPorPagar() {
      console.info("-------------------------", this.listaDistibucion);
      let nuevaLista = JSON.parse(JSON.stringify(this.listaDistibucion));
      nuevaLista = nuevaLista.filter(
        (l) => l.montoDistribuido != null && l.montoDistribuido > 0
      );

      return nuevaLista;
    },
    listaDistibucionPorProgramar() {
      let kit = [];
      let nuevaLista = JSON.parse(JSON.stringify(this.listaDistibucion));
      this.listaTratamientosLimpia.forEach((element) => {
        if (element.idKitTratamientos != null) {
          if (
            element.listaTratamientos.filter((lt) => lt.montoDistribuido == 0)
              .length > 0
          ) {
            kit.push(element);
          }
        }
      });

      nuevaLista = nuevaLista.filter(
        (l) =>
          (l.montoDistribuido == null || l.montoDistribuido == 0) &&
          l.idKitTratamientos == null
      );
      if (kit.length > 0) {
        kit.forEach((element) => {
          element.montoDistribuido = 0;
          element.subTotal = 0;
          element.listaTratamientos = element.listaTratamientos.filter(
            (lt) => lt.montoDistribuido == 0 || lt.montoDistribuido == null
          );
          let subTotal = 0;
          element.listaTratamientos.forEach((lt) => {
            let precio = lt.precioSesion - lt.saldoFavor;
            subTotal = subTotal + precio;
          });
          element.subTotal = subTotal;
          element.precioOriginalSesion = subTotal;
          nuevaLista.push(element);
        });
      }

      return nuevaLista;
    },
    totalCuponesM() {
      let total = 0;
      let porcentaje = 0;
      if (this.cuponSeleccionado.length > 0) {
        let idTratamiento = this.cuponSeleccionado[0].idTratamiento;
        if (idTratamiento != null) {
          total = this.calcularDescuentoPorTratamiento();
        } else {

          this.listaDistibucion.forEach((d) => {
            if (d.idPromocion == null || d.idCupon == null) {

              if (this.cuponSeleccionado[0].idTipoDescuentoCupon == 1) {

                porcentaje =
                  (d.precioSesion  / 100) *
                  this.cuponSeleccionado[0].cantidadDescuento;
                total += porcentaje;
              } else {
                total = this.cuponSeleccionado[0].cantidadDescuento;
              }
            }
          });

          this.tratamientosSesion.forEach((d) => {

            if (d.idPromocion == null && d.idCupon == null) {

              if (this.cuponSeleccionado[0].idTipoDescuentoCupon == 1) {
                
                porcentaje =
                  (d.precioSesion  / 100) *
                  this.cuponSeleccionado[0].cantidadDescuento;
                total += porcentaje;

              } else {
                total = this.cuponSeleccionado[0].cantidadDescuento;
              }
            }
          });
        }
      }
      return Math.floor(total);
    },
    cuponesTratamiento() {
      let total = 0;
      this.descuentoPorTratamiento.forEach((d) => {
        total += d;
      });
      return total;
    },
    totalFinal() {
      let total = 0;
      total = this.total - this.totalCuponesM;
      if (total < 0) {
        return 0;
      }
      return total;
    },
    totalFinalVista() {
      let descuento = 0;
      this.listaDistibucion.forEach((d) => {
        if (d.montoCupon > 0 || d.descuentoCupon > 0) {
          descuento += d.montoCupon;
        }
        if (d.listaTratamientos != null) {
          d.listaTratamientos.forEach((t) => {
            if (t.montoCupon > 0 || t.descuentoCupon > 0) {
              descuento += t.montoCupon;
            }
          });
        }
      });
      if (this.cuponActivo == true) {
        sessionStorage.setItem("totalFinalVista", this.totalFinal);
        return this.totalFinal;
      } else {
        sessionStorage.setItem("totalFinalVista", this.totalOriginal - descuento);
        return this.totalOriginal - descuento;
      }
    },
    /*subtotalFinal(){
      let subtotal = 0;
      this.tratamientosSesion.forEach(ts=>{
        if(this.cuponSeleccionado.length > 0){
          if(ts.idTratamiento == this.cuponSeleccionado[0].idTratamiento){
            subtotal = ts.subTotal - this.cuponSeleccionado[0].cantidadDescuento;
          }else{
            subtotal = ts.subTotal;
          }
        }else{
          subtotal = ts.subTotal;
        }
      })
      return subtotal;
    },*/
    restanteFinal() {
      let restanteFinal = this.total;
      restanteFinal = this.total - this.pagosFinal - this.totalCuponesM;
      if (restanteFinal < 0) {
        return 0;
      }
      return Math.floor(restanteFinal);
    },
    pagosFinal() {
      let pagosFinal = 0;
      this.pagos
        .map((item) => item.monto)
        .forEach((item) => {
          pagosFinal += parseFloat(item);
        });
      this.pagosDistibucion
        .map((item) => item.monto)
        .forEach((item) => {
          pagosFinal += Math.floor(parseFloat(item));
        });
      return pagosFinal;
    },
    abonoSaldoFinal() {
      let abonoSaldoFinal = 0;
      if (this.pagosFinal > this.totalFinal) {
        return this.pagosFinal - this.totalFinal;
      }
      return abonoSaldoFinal;
    },
    descuentoTotal() {
      let descuento = 0;
      if (this.cuponSeleccionado.length > 0) {
        if (this.descuentoPorTratamiento.length == 0) {
          if (this.cuponSeleccionado[0].idTipoDescuentoCupon == 2) {
            descuento =
              this.cuponSeleccionado[0].cantidadDescuento + this.descuentoCupon;
          } else {
            descuento = this.totalCuponesM + this.descuentoCupon;
          }
        } else {
          descuento = this.cuponesTratamiento + this.descuentoCupon;
        }
      }
      return descuento;
    },
  },

  watch: {
    "pago.monto": function (val) {
      if (val == 0) {
        this.pago.formaPago = null;
      }
    },
    "pago.formaPago": function (val) {
      if (this.pago.formaPago !== null && val.idFormaPago === this.formasPagoValidar.tdc) {
        this.obtenerConfiguracionPlazos();
      }
    },
    cuponSeleccionado() {
      if (this.cuponActivo == true && this.cuponSeleccionado.length == 0) {
        this.cuponActivo = false;
      }
    },
    codigo() {
      if (this.codigo != null && this.codigo.length > 0) {
        this.marketing = false;
      } else {
        this.marketing = true;
      }
    },
  },
  methods: {
    reestablecerMontos() {
      this.tipoPago = 1;
      this.pago.tipoPago = 1;
      this.pago.monto = null;
      this.pago.formaPago = null;
      this.bloquearMonto = false;
      this.limpiarCampos();
    },
    obtenerConfiguracionPlazos() {
      const params = { idClinica: this.$localStorageService.getIdClinica() };
      this.$http
        .post(this.$api + "plazoFijo/obtenerDetalleMsi", params)
        .then((response) => {
          if (response.data.data) {
            this.configuracionesMsi = response.data.data;

            this.configuracionesMsi = this.configuracionesMsi.filter(
              (msi) => msi.registroActivo
            );
          }
        });
    },
    cambiarTipoPago(valor) {
      this.pago.tipoPago = valor;
      this.limpiarCampos();
      this.msis = [];
      if (valor === 2) {
        this.configuracionesMsi.forEach((item) => {
          if (item.estatusMsi && this.pago.monto >= item.montoMinimoMsi) {
            this.msis.push(item.meses);
          }
        });

        this.bloquearMonto = true;
      } else if (valor === 1) {
        this.pago.idBanco = null;
        this.formasConBancosTerminalesFiltro = this.formasConBancosTerminales[0].listaBancosTerminalesBancarias;
      }
    },
    filtarBancoTerminal() {
      this.pago.idBanco = null;

      this.formasConBancosTerminalesFiltro = this.bancosPlazoFijo.filter(
        (b) => b.meses === this.pago.msi
      );
    },
    filtroBancos(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      let bancoTerminal = this.formasConBancosTerminales.filter(bancoTerminal=>bancoTerminal.idFormaPago === this.pago.formaPago.idFormaPago)[0].listaBancosTerminalesBancarias;
      this.formasConBancosTerminalesFiltro = bancoTerminal.filter((em) => {
        return em.nombreBanco.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtroFinancieras(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.financierasFiltro = this.financieras.filter((em) => {
        return em.financiera.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    filtroFormas(busqueda, loading) {
      loading(true);
      let seach = busqueda.trim();
      this.formasFiltro = this.formas.filter((em) => {
        return em.nombreForma.toLowerCase().includes(seach.toLowerCase());
      });
      loading(false);
    },
    newPago() {
      return {
        monto: null,
        formaPago: null,
        financiera: null,
        referencia: null,
        idBanco: null,
        afiliacion: null,
        numeroTarjeta: null,
        msi: null,
        idFormaPagoTemporal: null,
      };
    },
    mensajeFaltaHc() {
      this.$swal({
        icon: "question",
        text: "No existe historia clínica o no tiene los datos obligatorios. Debes crearla o completarla para poder cerrar el cobro.",
        confirmButtonColor: "#0e6ba9",
        cancelButtonColor: "#8e8e8e",
        confirmButtonText: "OK",
        cancelButtonText: "NO",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$router.push({
            name: "pacienteses",
            params: {
              id: this.informacionSesion.idPaciente,
              sesion: this.idSesion,
            },
          });
        }
      });
    },

    async validarExiteSesionORecibo(parametro) {
      this.$http
        .post(this.$api + "caja/validacionesCobro", parametro)
        .then((res) => {
          if (res.data.data) {
            this.cobrarCaja(parametro);
          }

          if (res.status === 417) {
            this.mensajeFaltaHc();
          }
        })
        .catch((error) => {
          console.error(error);
          this.$swal({
            icon: "warning",
            text: error.response.data.message,
            confirmButtonColor: "#0e6ba9",
            cancelButtonColor: "#8e8e8e",
            confirmButtonText: "OK",
            cancelButtonText: "NO",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
          });

          this.progresBar.variant = "danger";
          this.progresBar.progreso = 100;
        });
    },

    cobrarCaja(body) {
      if(body.cuponCuenta.length > 0){
        body.totalmontoCupon = this.totalCuponesM;
      }else if(body.cuponTratamiento.length > 0){
         body.totalmontoCupon = body.tratamientosSesionPorPagar.reduce((acumulador, tx) => {
            if (tx.cupon != null) {
              return acumulador + tx.cupon;
            }
            return acumulador;
          }, 0);
      }
      this.$http
        .post(this.$api + "caja/guardar/pago/tratamientoSesion", body)
        .then((res) => {
          if (res.status === 200) {
            if (
              res.data.data.tratamientosInactivos.length > 0 &&
              res.data.data.idRecibo === null
            ) {
              this.tratamientosInactivos = res.data.data.tratamientosInactivos;
              this.tratamientosDePti = res.data.data.tratamientosPti;
              this.$refs["validadorTrtsActivos"].show();
            } else if (res.data.data.idRecibo === null && !res.data.data.existeBloqueo) {
              this.$swal({
                icon: "warning",
                html: `<div style="border-radius: 200px;"><h5 style="font-weight: bold; paddin-bottom: 0px"> Se detectaron cambios en los tratamientos de la sesión actual.</h5> <br> <p style="font-size: small"> Serás redirigido al Dashboard. <br>
                  Deberás ingresar nuevamente a la caja.</p></div>`,
                confirmButtonText: "Cerrar",
                confirmButtonColor: "#7B7D7D",
                onClose: () => {
                  this.regresarPantalla();
                },
              });
            } else {
              this.progresBar.progreso = 100;
              this.$swal({
                icon: "success",
                html: `<div style="border-radius: 200px;"><h5 style="font-weight: bold; paddin-bottom: 0px"> Cobro realizado</h5> <br> <p style="font-size: medium"> El cobro se realizó correctamente </p></div>`,
                confirmButtonText: "Cerrar",
                confirmButtonColor: "#7B7D7D",
                onClose: () => {
                  this.cerrarCobro();
                  this.obtenerInformacionSesion();
                  this.idRecibo = res.data.data.idRecibo;
                },
              });
              this.distribuir = false;
              this.etapaRecibo = true;
            }
          }
        })
        .catch((error) => {
          console.error(error.response.data.message);
          this.$swal({
            icon: "warning",
            text: error.response.data.message,
            confirmButtonColor: "#0e6ba9",
            cancelButtonColor: "#8e8e8e",
            confirmButtonText: "OK",
            cancelButtonText: "NO",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
          });

          this.progresBar.variant = "danger";
          this.progresBar.progreso = 100;
        })
        .finally(() => {
          this.realizandoPago = false;
          this.emepezarPago = false;
        });
    },

    validarPago() {
      const params = {
        idSesion: this.idSesion,
      };
      const url = this.$api + "sesion/recibo";
      this.$http
        .post(url, params)
        .then((response) => {
          if (response.data.data.idRecibo != null) {
            this.idRecibo = response.data.data.idRecibo;
            this.idFactura = response.data.data.idFactura;
          } else {
            this.obtenerTratamientosDeLaSesion();
            this.obtenerCatalogos();
            this.bloquearAccionesTratamientosSesion();
          }
        })
        .finally(() => this.verificarFinCargaInicial(1));
    },
    obtenerTratamientosDeLaSesion() {
      this.loaderPrincipal = true;
      const parametros = { idSesion: this.idSesion };
      this.$http
        .post(this.$api + "tratamiento_sesion/caja", parametros)
        .then((response) => {
          if (response.data.data) {
            this.tratamientosSesion = response.data.data;
            if (
              this.tratamientosSesion.length > 0 &&
              !this.tratamientosSesion[0].tieneHcLlena
            ) {
              this.hcLlenaPaciente = this.tratamientosSesion[0].tieneHcLlena;
              this.mensajeFaltaHc();
            }

            let totalSaldoFavor = 0.0;
            let totalPrecioSesion = 0.0;
            let ajuste = 0.0;
            this.tratamientosSesion.map((item) => {
              let redondeo = 0.0;
              let subtotal = 0.0;
              if (item.saldoFavor > item.precioSesion) {
                item.subTotal = 0;
              } else {
                item.subTotal = item.precioSesion - item.saldoFavor;
                subtotal = item.precioSesion - item.saldoFavor;
                redondeo = Math.floor(subtotal);
              }
              if (item.descuento != null && item.descuento > 0) {
                this.descuento +=
                  (item.precioOriginalSesion * item.descuento) / 100;
              }
              totalSaldoFavor += item.saldoFavor;
              totalPrecioSesion += item.precioSesion;
              this.subtotal += item.precioOriginalSesion;
              this.total += item.subTotal;
              this.saldoTrtamientos += item.saldoFavor;
              ajuste += subtotal - redondeo;
            });
            this.tratamientosSesion.map((item) => {
              if (item.numeroSesion == 1) {
                item.subTotal = item.subTotal + ajuste;
              } else {
                item.subTotal = Math.floor(item.subTotal);
              }
            });

            if (this.tratamientosSesion.length > 0) {
              this.cubreSaldo = totalSaldoFavor >= totalPrecioSesion;
            }
            this.restante = this.total;
            this.buscarTratamientosSinRealizar();
          }
        })
        .finally(() => {
          this.obtenerInformacionPTI();
          this.changeSaldoFinal();
          this.loaderPrincipal = false;
          this.verificarFinCargaInicial(2);
          this.obtenerSaldoVale();
        });
    },
    obtenerMeses() {
      this.msis = [];
      if (
        this.pago.formaPago != null &&
        this.pago.formaPago.idFormaPago === this.formasPagoValidar.financiamiento &&
        this.pago.monto != null &&
        this.pago.financiera != null
      ) {
        const parametros = {
          monto: this.pago.monto,
          idFinanciera: this.pago.financiera,
        };
        this.$http
          .post(this.$api + "forma/listar/meses", parametros)
          .then((res) => {
            if (res.data.data) {
              this.msis = res.data.data;

              if (this.pago.msi != null && !this.msis.includes(this.pago.msi)) {
                this.pago.msi = null;
              }
            }
          });
      }

      if (
        this.pago.formaPago != null &&
        this.pago.formaPago.idFormaPago === this.formasPagoValidar.tdc &&
        this.pago.monto != null
      ) {
        const parametros = { monto: this.pago.monto };
        this.$http
          .post(this.$api + "forma/catalogo/listaFormasDetalle", parametros)
          .then((res) => {
            if (res.data.data) {
              let msi = [];
              if (res.data.data.msi) {
                var regex = /(\d+)/g; // EXPRESION REGULAR PARA ENCONTRAR NUMEROS
                res.data.data.msi.forEach((f) => {
                  let numeros = parseInt(f.detalleForma.match(regex));
                  msi.push(numeros);
                });
                msi.sort((a, b) => a - b); // Ordenar numeros
              }
            }
          });
      }
    },
    agregarPago() {
      if (
        this.tipoPago === 1 &&
        this.pago.formaPago.idFormaPago === this.formasPagoValidar.tdc &&
        this.pago.msi == null
      ) {
        this.pago.msi = 0;
      }

      if (!this.validaciones()) {
        return false;
      }

      this.totalPagado += +this.pago.monto;

      if (this.totalPagado + this.totalCuponesM > this.total) {
        this.abonoSaldo = this.totalPagado - this.totalFinal;
        this.changeSaldoFinal();
        this.restante = 0;
      } else {
        this.restante = this.total - this.totalCuponesM - this.totalPagado;
      }

      let enocontro = false;
      this.pagos.map((p) => {
        if (
          this.pago.formaPago.idFormaPago === p.formaPago.idFormaPago &&
          this.pago.referencia === p.referencia
        ) {
          p.monto = parseFloat(p.monto) + parseFloat(this.pago.monto);
          enocontro = true;
        }
      });
      if (!enocontro) {
        this.pagos.push(this.pago);
      }

      this.pago = this.newPago();
      this.$v.$reset();
      this.cerrarModal();
      this.totalAbonar();
      this.formasConBancosTerminalesFiltro = this.formasConBancosTerminales[0].listaBancosTerminalesBancarias;
    },
    eliminarPago(item) {
      this.$swal
        .fire({
          icon: "info",
          title: "Aviso",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCancelButton: true,
          showConfirmButton: true,
          text: "¿Desea quitar el pago?",
        })
        .then((aceptar) => {
          if (aceptar.value) {
            this.totalPagado -= item.monto;
            if (this.totalPagado < this.total) {
              this.restante = this.totalFinal - this.totalPagado;
              this.abonoSaldo = 0;
            } else {
              this.abonoSaldo = this.totalPagado - this.totalFinal;
            }
            this.changeSaldoFinal();

            this.pagos.splice(this.pagos.indexOf(item), 1);
            this.totalAbonar();
          }
        });
    },
    editarPagoDribucion(item, index) {
      this.pagoSeleccionado = index;
      this.pago = JSON.parse(JSON.stringify(item));
      this.tipoPago = this.pago.tipoPago;
      this.booleanMsi = false;
      if (
        this.pago.idFormaPagoTemporal !== null &&
        this.pago.idMetodoPago === 2 &&
        this.pago.msi === null
      ) {
        this.pago.msi = 0;
      }
      this.formasConBancosTerminalesFiltro = this.formasConBancosTerminales.filter(bancoTerminal => bancoTerminal.idFormaPago === this.pago.formaPago.idFormaPago)[0].listaBancosTerminalesBancarias;
      if (this.pago.msi === 0) {
        this.bancosClinicaPlazoFijo = this.formasConBancosTerminalesFiltro;
      } else {
        this.bancosClinicaPlazoFijo = this.bancosPlazoFijo.filter(
          (b) => b.meses === this.pago.msi
        );
      }
      this.abrirModalPago(0);
    },
    modificarPago() {
      if (!this.validaciones()) {
        return false;
      }

      console.log("this.pago", this.pago)
      this.pago.idBanco = this.pago.idBanco.idBanco;
      this.formaPagoCaja.forEach((fpc) => {
        if (fpc.idFormaPagoTemporal === this.pago.idFormaPagoTemporal) {
          fpc.idBanco = this.pago.idBanco;
          fpc.referencia = this.pago.referencia;
          fpc.numeroTarjeta = this.pago.numeroTarjeta;
        }
      });

      this.pagosDistibucion[this.pagoSeleccionado] = this.pago;
      this.pagosDesglosados
        .filter((p) => this.pago.idFormaPagoTemporal === p.idFormaPagoTemporal)
        .map((value) => {
          value.referencia = this.pago.referencia;
          value.idBanco = this.pago.idBanco;
          value.numeroTarjeta = this.pago.numeroTarjeta;
          value.msi = this.pago.msi;
          value.financiera = this.pago.financiera;
          value.afiliacion = this.pago.afiliacion;
        });

      this.pagosDistibucion.forEach((fpc) => {
        if (fpc.idFormaPagoTemporal === this.pago.idFormaPagoTemporal) {
          fpc.idBanco = this.pago.idBanco;
          fpc.referencia = this.pago.referencia;
          fpc.numeroTarjeta = this.pago.numeroTarjeta;
        }
      });

      this.pago = this.newPago();
      this.$v.$reset();
      this.cerrarModal();
    },
    buscarTratamientosSinRealizar() {
      const parametros = { idPaciente: this.informacionSesion.idPaciente };
      this.$http
        .post(this.$api + "diagnostico/tratamientios/noRealizados", parametros)
        .then((response) => {
          if (response.data.data) {
            response.data.data.map((t) => {
              t.editar = false;
              t.total = t.saldoFavor;
            });
            this.listaTratamientosSinRealizar = response.data.data;
          }
        })
        .finally(() => {
          this.verificarFinCargaInicial(3);
        });
    },
    validaciones() {
      this.$v.pago.$touch();
      if (this.$v.pago.$anyError) {
        return false;
      }

      if (this.pago.formaPago.idFormaPago === this.formasPagoValidar.aplicarSaldo) {
        if (this.pago.monto > this.restante) {
          this.pago.monto = this.restante;
        }
        if (this.saldofinal < this.pago.monto) {
          this.pago.monto = this.saldofinal;
        }

        this.saldofinal -= this.pago.monto;
      }

      if (
        this.pago.formaPago.idFormaPago === this.formasPagoValidar.financiamiento &&
        this.pago.monto < this.montoMinimoFinanciera
      ) {
        this.$swal({
          icon: "warning",
          text:
            "El monto del financiamiento debe ser con un mínimo de $" +
            this.montoMinimoFinanciera,
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      }
      return true;
    },
    obtenerInformacionSesion() {
      this.loaderInformacion = true;
      const parametros = { idSesion: this.idSesion };
      this.$http
        .post(
          this.$api + "caja/obtener-informacion/paciente/sesion",
          parametros
        )
        .then((res) => {
          if (res.status === 200) {
            this.informacionSesion = res.data.data;
          }
        })
        .finally(() => {
          this.loaderInformacion = false;
          this.verificarFinCargaInicial(4);
          this.verificarBloqueo();
        });
    },
    cerrarModalTratsActivos() {
      this.obtenerInformacionPTI();
      this.obtenerTratamientosDeLaSesion();
      this.$refs["validadorTrtsActivos"].hide();
    },
    obtenerInformacionPTI() {
      this.idPTI = null;
      this.idFlujoPti = null;
      this.idEtapa = null;
      this.existenTratamientosPTIReplica = false;
      this.loaderInformacion = true;
      const parametros = {
        idPaciente: this.informacionSesion.idPaciente,
        idSesion: this.idSesion,
      };
      this.$http
        .post(this.$api + "caja/obtener/ditribucion/pti", parametros)
        .then((res) => {
          if (res.status === 200) {
            this.idPTI = res.data.data.idPti;
            this.idFlujoPti = res.data.data.idFlujoPti;
            this.idEtapa = res.data.data.idEtapa;
            this.idSolicitud = res.data.data.idSolicitud;

            this.tratamientosInactivos = res.data.data.tratamientosInactivos;
            if (
              res.data.data.formaPagoCaja === null ||
              res.data.data.formaPagoCaja.length === 0
            ) {
              this.tratamientosDePti = false;
            }
            if (
              ((this.tratamientosInactivos !== null &&
                this.tratamientosInactivos.length > 0) ||
                this.idEtapa === null) &&
              this.tratamientosDePti
            ) {
              this.$refs["validadorTrtsActivos"].show();
            }

            this.totalTratamientosActivos = res.data.data.tratamientos.length;

            res.data.data.tratamientos.map((item) => {
              this.existenTratamientosPTIReplica =
                item.origenPTI === undefined ||
                item.origenPTI === null ||
                item.origenPTI === false;

              if (item.saldoFavor > item.precioSesion) {
                item.subTotal = 0;
              } else {
                item.subTotal = item.precioSesion - item.saldoFavor;
              }
              if (item.descuento != null && item.descuento > 0) {
                this.descuento +=
                  (item.precioOriginalSesion * item.descuento) / 100;
              }
              this.subtotal += item.precioOriginalSesion;
            });

            this.listaTratamientosLimpia = JSON.parse(
              JSON.stringify(res.data.data.tratamientos)
            );
            this.listaDistibucion = res.data.data.tratamientos;
            this.listaDistibucion.forEach((element) => {
              if (element.montoCupon != null) {
                this.descuentoCupon += element.montoCupon;
              }
              if (element.idKitTratamientos != null) {
                element.listaTratamientos = element.listaTratamientos.filter(
                  (lt) => lt.montoDistribuido > 0
                );
                let subTotal = 0;
                element.listaTratamientos.forEach((lt) => {
                  let precio = lt.precioSesion - lt.saldoFavor;
                  subTotal = subTotal + precio;

                  if (lt.montoCupon != null) {
                    this.descuentoCupon += lt.montoCupon;
                  }
                });
                element.subTotal = subTotal;
                element.precioOriginalSesion = subTotal;
              }
            });

            const formas = JSON.parse(JSON.stringify(res.data.data.formas));

            this.totalOriginal = this.total;
            this.pagosDesglosados = formas.map((p) => {
              p.idBanco = null;
              this.total += p.monto;
              this.totalPagado += p.monto;
              this.totalOriginal += p.monto;
              let encontrado = false;
              this.pagosDistibucion.map((p2) => {
                if (
                  p2.grupoPago === p.grupoPago &&
                  p2.formaPago.nombreForma === p.formaPago.nombreForma
                ) {
                  p2.monto += p.monto;
                  encontrado = true;
                }
              });
              if (!encontrado) {
                this.pagosDistibucion.push(JSON.parse(JSON.stringify(p)));
              }
              return p;
            });
            const montoAhorradoCupon =
              res.data.data.montos != null
                ? res.data.data.montos.montoAhorradoCupon
                : 0;
            this.totalOriginal = this.totalOriginal + montoAhorradoCupon;
            this.descuentoCupon =
              this.descuento == 0 ? this.descuentoCupon : montoAhorradoCupon;
            this.restante = this.total - this.totalPagado;
            this.totalAbonar();

            if (
              res.data.data.tratamientos.length > 0 &&
              !res.data.data.tratamientos[0].tieneHcLlena
            ) {
              this.hcLlenaPaciente = res.data.data.tratamientos[0].tieneHcLlena;
              this.mensajeFaltaHc();
            }

            this.formaPagoCaja = res.data.data.formaPagoCaja;
            this.montoFinanciar = res.data.data.montoFinanciar;
            sessionStorage.setItem("montoFinanciar", this.montoFinanciar);

            this.formaPagoCaja.forEach((f) => {
              this.dineroDistribuido += f.monto;
            });
          }
        })
        .finally(() => {
          this.loaderInformacion = false;
          this.verificarFinCargaInicial(5);
          this.obtenerCupones();
          this.obtenerSaldoVale();
        });
    },

    obtenerCatalogos() {
      this.$http
        .get(this.$api + "catalogos/listaFormas")
        .then((res) => {
          if (res.data.data) {
            this.formas = res.data.data;
            this.formasFiltro = this.formas;
          }
        })
        .finally(() => {
          this.verificarFinCargaInicial(6);
        });
      this.$http.post(this.$api + "formaPagoBanco/obtenerFormasPagoConBancoTerminalBancaria").then((res) => {
        if (res.data.data) {
          this.formasConBancosTerminales = res.data.data;
          this.formasConBancosTerminalesFiltro = this.formasConBancosTerminales[0].listaBancosTerminalesBancarias; // sirve para dejar dato por defecto
        }
      }).finally(() => {
        this.verificarFinCargaInicial(7);
      });
      const parametros = {
        idClinica: this.$localStorageService.getIdClinica(),
      };
      this.$http
        .post(this.$api + "plazoFijo/obtener/bancosMsi", parametros)
        .then((res) => {
          if (res.data.data) {
            res.data.data.forEach(plazoFijo => {
              this.bancosPlazoFijo.push({nombreBanco: plazoFijo.nombre, idBanco: plazoFijo.idTerminal, meses: plazoFijo.meses});
            })
          }
        })
        .finally(() => {});
      this.$http
        .get(this.$api + "financiera/obtener")
        .then((res) => {
          if (res.data.data) {
            this.financieras = res.data.data;
            this.financierasFiltro = this.financieras;
          }
        })
        .finally(() => {
          this.verificarFinCargaInicial(9);
        });
    },

    validarTratamientosDisponibles() {
      this.tratamientosCupon = [];
      this.tratamientosSesion.forEach((i) => {
        if (i.idKitTratamientos == null) {
          if (
            i.idCupon == null &&
            i.idPromocion == null &&
            i.precioSesion > 0 &&
            i.precioSesion != null &&
            i.idKitTratamientos == null &&
              i.idTipoDescuentoPlan !== 3
          ) {
            if (!this.tratamientosCupon.includes(i.idTratamiento)) {
              this.tratamientosCupon.push(i.idTratamiento);
            }
          }
        } else {
          i.listaTratamientos.forEach((lt) => {
            if (
              lt.montoCupon == 0 &&
              lt.montoPromocion == 0 &&
              lt.precioSesion > 0 &&
              lt.precioSesion != null
            ) {
              if (!this.tratamientosCupon.includes(lt.idTratamiento)) {
                this.tratamientosCupon.push(lt.idTratamiento);
              }
            }
          });
        }
      });
      this.listaDistibucion.forEach((i) => {
        if (i.idKitTratamientos == null) {
          if (
            i.montoCupon == null &&
            i.montoPromocion == null &&
            i.precioSesion > 0 &&
            i.precioSesion != null
          ) {
            if (!this.tratamientosCupon.includes(i.idTratamiento)) {
              this.tratamientosCupon.push(i.idTratamiento);
            }
          }
        } else {
          i.listaTratamientos.forEach((lt) => {
            if (
              lt.montoCupon == 0 &&
              lt.montoPromocion == 0 &&
              lt.precioSesion > 0 &&
              lt.precioSesion != null
            ) {
              if (!this.tratamientosCupon.includes(lt.idTratamiento)) {
                this.tratamientosCupon.push(lt.idTratamiento);
              }
            }
          });
        }
      });
    },

    obtenerCupones() {
      this.validarTratamientosDisponibles();
      this.cuponesDisponibles = [];
      if (this.tratamientosCupon.length > 0) {
        const params = {
          idPaciente: this.informacionSesion.idPaciente,
          idsTratamientos: this.tratamientosCupon,
        };
        this.cuponesService.obtenerCupones(params).then((response) => {
          let mismoCupon = false;
          this.cuponesDisponibles.push(...response.data.cuponDTO);
          const listIdCupones = this.cuponesDisponibles.map((i) => i.idCupon);
          const idCupones = listIdCupones.filter((valor, index) => {
            return listIdCupones.indexOf(valor) == index;
          });
          let cuponRepetido = 0;
          this.cuponesDisponibles.forEach((c) => {
            for (let index = 0; index < listIdCupones.length; index++) {
              if (c.idCupon == listIdCupones[index]) {
                cuponRepetido++;
              }
            }
          });
          if (cuponRepetido > listIdCupones.length) {
            mismoCupon = true;
          }

          const cupon = this.cuponesDisponibles.filter((c) =>
            listIdCupones.includes(c.idCupon)
          );
          if (cupon.length > 0) {
            for (let index = cupon.length; index > 0; index--) {
              if (mismoCupon) {
                this.listIdTrt = [];
                this.cuponesDisponibles.forEach((cd) => {
                  if (cd.idCupon == listIdCupones[index]) {
                    this.listIdTrt.push(cd.idTratamiento);
                  }
                });
              }
            }
            if (this.listIdTrt.length > 1) {
              this.cuponesDisponibles.forEach((c) => {
                c.idTratamiento = this.listIdTrt;
              });

              let r = 0;
              this.cuponesDisponibles.forEach((element) => {
                if (element.idCupon == idCupones) {
                  r++;
                }
              });
              for (var i = 0; i < r - 1; i++) {
                idCupones.forEach((id) => {
                  let posEliminar = listIdCupones.findIndex((l) => l == id);
                  this.cuponesDisponibles.splice(posEliminar, 1);
                });
              }
            }
          } else {
            if (mismoCupon) {
              const listIdTrt = this.cuponesDisponibles.map(
                (i) => i.idTratamiento
              );

              if (listIdTrt.length > 1) {
                this.cuponesDisponibles.forEach((c) => {
                  c.idTratamiento = listIdTrt;
                });
                this.cuponesDisponibles.pop();
              }
            }
          }
          this.cuponesDisponibles.push(...response.data.cuentaCuponDTO);
          this.cuponesDisponibles.forEach((cd) => {
            if (cd.idTratamiento != null && cd.idTratamiento.length > 1) {
              var length = cd.idTratamiento.length;
              for (var i = 0; i < length; i++) {
                for (var j = 0; j < length - i - 1; j++) {
                  if (cd.idTratamiento[j] > cd.idTratamiento[j + 1]) {
                    var tmp = cd.idTratamiento[j];
                    cd.idTratamiento[j] = cd.idTratamiento[j + 1];
                    cd.idTratamiento[j + 1] = tmp;
                  }
                }
              }
            }
          });
        });
      }
    },

    async obtenerEstatusEdicion() {
      const params = {
        idSolicitud: this.idSolicitud,
      };
      if (this.idEtapa == 100) {
        await this.$http
          .post(this.$api + "edicion/obtener/estatusEdicion", params)
          .then((resp) => {
            this.registroActivo = resp.data.data;
          });
      }
    },

    async cobrar() {
      if (this.idEtapa == 100) {
        await this.obtenerEstatusEdicion();
        if (this.registroActivo === false) {
          this.$swal({
            width: "650px",
            icon: "warning",
            title:
              "<h6 style='font-size: 12px' ><b>La solicitud de Edición PTI ha sido cancelada</b></h6>",
            html: '<div style="font-size: 12px"> ¡Por favor verifique la información! </div> <br>',
            showCloseButton: true,
            showCancelButton: false,
            confirmButtonText: "De acuerdo",
            confirmButtonColor: "rgb(110,163,197)",
            customClass: {
              confirmButton: "pl-5 pr-5 mr-1 mr-sm-5 rounded-pill",
              cancelButton: "pl-5 pr-5 mr-1 mr-sm-5 rounded-pill",
            },
          }).then((aceptar) => {
            if (aceptar.value) {
              this.$router.push("/dashboard");
            }
          });
          return false;
        }
      }

      this.emepezarPago = true;
      /*const validar = await this.validarExiteOGCabezera();

      if(validar.data.data === true){
        this.$swal({
          icon: "info",
          text: "El paciente no cuenta con OG de cabecera, favor de realizar la asignación",
          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "OK",
          cancelButtonText: "NO",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: false,
        }).then((aceptar) => {
          if (aceptar.value) {
            this.$router.push({
              name: "dashboard",
            })
          }
        });
        this.emepezarPago = false;
        return false;
      }*/

      if (this.restante > 0 && this.saldofinal > 0) {
        this.$swal({
          icon: "warning",
          title: "No puede generar un adeudo si cuenta con saldo",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#0e6ba9",
          onClose: () => {
            this.pago = this.newPago();
            this.pago.monto = this.restante;
            this.pago.formaPago = {
              idFormaPago: 6,
              nombreForma: "APLICAR SALDO",
            };
            this.agregarPago();
          },
        });
        this.emepezarPago = false;
        return false;
      }
      if (
        this.pagosDistibucion
          .filter((p) => [2, 3, 4].includes(p.formaPago.idFormaPago))
          .filter((p) => p.idBanco === null).length > 0
      ) {
        this.$swal({
          icon: "warning",
          title: "Aun cuentas con pagos sin completar",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#0e6ba9",
        });
        this.emepezarPago = false;
        return false;
      }

      if (!this.distribuir && this.validarDistribucion()) {
        this.distribuir = true;
        this.emepezarPago = false;
        return false;
      }

      const formas = [];

      this.pagos.map((pago) => {
        pago.idFormaPago = pago.formaPago.idFormaPago;

        if (pago.idBanco != null) {
          pago.afiliacion = pago.idBanco.afiliacion;
          pago.idBanco = pago.idBanco.idBanco;
        }
        formas.push(pago);
      });
      const formasDistribucion = [];

      this.pagosDesglosados.map((pago) => {
        pago.idFormaPago = pago.formaPago.idFormaPago;
        if (pago.idBanco != null) {
          if (
            pago.idBanco.afiliacion != null ||
            pago.idBanco.afiliacion != undefined
          ) {
            pago.afiliacion = pago.idBanco.afiliacion;
            pago.idBanco = pago.idBanco.idBanco;
          }
        } else {
          let formaPago = this.formaPagoCaja.filter(
            (pf) => pf.idFormaPagoTemporal === pago.idFormaPagoTemporal
          );
          if (
            (formaPago !== null || formaPago !== undefined) &&
            pago.idFormaPago === this.formasPagoValidar.tdc &&
            pago.idFormaPago === this.formasPagoValidar.tdd
          ) {
            pago.idBanco = formaPago[0].idBanco;
            pago.numeroTarjeta = formaPago[0].numeroTarjeta;
            pago.referencia = formaPago[0].referencia;
          }
        }
        formasDistribucion.push(pago);
      });

      const body = {
        idSesion: this.idSesion,
        total: this.total,
        formasDepago: formas,
        formasDepagoD: formasDistribucion,
        tratamientosSesionPorPagar: this.tratamientosSesionPorPagar,
        tratamientos: this.listaTratamientosSinRealizar.filter(
          (t) => t.abono > 0
        ),
        cuponCuenta: this.cuponSeleccionado.filter(
          (c) => c.idTipoAplicacion == 1
        ),
        cuponTratamiento: this.cuponSeleccionado.filter(
          (c) => c.idTipoAplicacion == 2
        ),
      };
      this.realizandoPago = true;
      this.progresBar.variant = "success";
      this.progresBar.progreso = 60;

      this.validarExiteSesionORecibo(body);
    },

    validarDistribucion() {
      this.totalAbonar();

      if (
        this.totolaAbonar > 0 &&
        this.listaTratamientosSinRealizar.length > 0
      ) {
        this.totalDistribuido = 0;

        let variable = this.totolaAbonar;
        this.listaTratamientosSinRealizar.map((t) => {
          if (variable > 0) {
            const monto = t.precioSesion - t.saldoFavor;
            if (monto <= variable) {
              t.abono = monto;
              variable -= monto;
            } else {
              t.abono = variable;
              variable = 0;
            }
            this.totalDistribuido += t.abono;
            t.total = t.saldoFavor + t.abono;
          }
        });
        this.totolaRestanteDistribuir =
          this.totolaAbonar - this.totalDistribuido;
        return true;
      }
      return false;
    },

    changeSaldoFinal() {
      let saldoAFavorPagos = 0.0;
      this.pagos.map((p) => {
        if (p.formaPago.idFormaPago == this.formasPagoValidar.aplicarSaldo) {
          saldoAFavorPagos += p.monto;
        }
      });
      this.saldofinal =
        this.informacionSesion.saldo -
        this.saldoTrtamientos -
        saldoAFavorPagos +
        this.abonoSaldo;
    },
    totalAbonar() {
      this.totolaAbonar = 0.0;
      let saldoAFavorPagos = 0.0;

      this.pagos.map((p) => {
        if (p.formaPago.idFormaPago == this.formasPagoValidar.aplicarSaldo) {
          saldoAFavorPagos += p.monto;
        }
      });

      let saldo =
        this.informacionSesion.saldo - this.saldoTrtamientos - saldoAFavorPagos;

      if (saldo > 0) {
        this.totolaAbonar = this.abonoSaldo;
      } else {
        this.totolaAbonar = saldo += this.abonoSaldo;
      }
    },

    cerrarCobro() {
      const parametros = {
        idSesion: this.idSesion,
        comentarios: "CIERRE DE SESION POR MEDIO DEL PAGO SESION",
        idPaciente: this.informacionSesion.idPaciente,
      };
      this.$http
        .post(this.$api + "agenda/cerrarSesion", parametros)
        .then(() => {})
        .catch((error) => {
          console.error(error);
          this.$swal({
            icon: "error",
            title: "Error al cerrar el cobro",
            text: error.response.data.message,
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        })
        .finally(() => {
          this.cerrando = false;
          if (this.listaDistibucion.length > 0) {
            // this.validarPtiAltoRiesgo();
          }
        });
    },
    /*validarPtiAltoRiesgo() {
      const params = {
        idPaciente: this.informacionSesion.idPaciente
      }
      this.$http
          .put(this.$api + "ptialtoriesgo/validarptialtoriesgo/idPaciente", params )
          .then(() => {
          })
          .catch((error) => {
            console.error("Error:  pti alto riesgo: " + error);
          });
    },*/

    quitarAbono(item) {
      this.totalDistribuido -= parseFloat(item.abono);
      this.totolaRestanteDistribuir = this.totolaAbonar - this.totalDistribuido;
      item.abono = 0.0;
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode === 46) {
        $event.preventDefault();
      }
    },

    editarAbono() {
      this.totalDistribuido = 0;

      this.listaTratamientosSinRealizar.map((it) => {
        if (it.abono !== "") {
          const dato = this.totalDistribuido + parseFloat(it.abono);
          const validador = it.saldoFavor + parseFloat(it.abono);
          if (validador > it.precioSesion && it.idTratamiento !== 1982) {
            it.abono = (it.precioSesion - it.saldoFavor).toString();
            it.editar = false;
          }

          if (dato > this.totolaAbonar && dato < this.totolaAbonar) {
            it.abono = (this.totolaAbonar - this.totalDistribuido).toString();
            it.editar = false;
          }
          this.totalDistribuido = this.totalDistribuido + parseFloat(it.abono);
        }
      });
    },

    async regresarPantalla() {
      this.$router.push({ name: "dashboard" });
    },

    obtenerMinimoFinanciera(idFinanciera) {
      this.pago.msi = null;
      const parametros = { idFinanciera: idFinanciera };
      this.formaPagoService.obtenerMinimoFinanciera(parametros).then((r) => {
        this.montoMinimoFinanciera = r;

        if (this.pago.monto >= this.montoMinimoFinanciera) {
          this.obtenerMeses();
          this.booleanMsi = true;
        } else {
          this.booleanMsi = false;
          this.$swal({
            position: "top",
            showConfirmButton: false,
            timer: 4200,
            toast: true,
            icon: "info",
            title:
              "El monto no coincide con el mínimo de la financiera que es de: $" +
              this.montoMinimoFinanciera,
          });
        }
      });
    },
    eliminarRecibo(renegociarPTI) {
      const url = this.$api + "sesion/cancelar/activar";

      const envio = {
        idSesion: this.idSesion,
        estatus: 1,
        usuarioLogueado: this.$localStorageService.getIdUsuario(),
        idClinica: this.$localStorageService.getIdClinica(),
        idPaciente: this.informacionSesion.idPaciente,
        comentarios:
          "ACTIVAR SESION POR CANCELACION DE RECIBO DESDE LA PANTALLA DE COBRO DE SESION",
        motivo: 4,
      };

      this.$http.put(url, envio).then((response) => {
        if (response.status === 200) {
          this.idRecibo = null;

          if (renegociarPTI) {
            this.$router.push("/dashboard");
          } else {
            if (this.$route.name === "cajaSesion") {
              this.$router.go(0);
            } else {
              this.$router.push({
                name: "cajaSesion",
                params: this.$route.params,
              });
            }
          }
          location.reload();
        }
      });
    },

    limpiarCampos() {
      this.obtenerMeses();
      this.pago.referencia = null;
      this.pago.idBanco = null;
      this.pago.financiera = null;
      this.pago.numeroTarjeta = null;
      this.pago.msi = null;
      this.booleanMsi = !(this.pago.formaPago.idFormaPago === this.formasPagoValidar.financiamiento);
      if (this.pago.formaPago.idFormaPago === this.formasPagoValidar.tdc || this.pago.formaPago.idFormaPago === this.formasPagoValidar.tdd || this.pago.formaPago.idFormaPago === this.formasPagoValidar.transferencia){
        this.formasConBancosTerminalesFiltro = this.formasConBancosTerminales.filter(bancoTerminal => bancoTerminal.idFormaPago === this.pago.formaPago.idFormaPago)[0].listaBancosTerminalesBancarias;
      }
    },
    abrirModalPago(accion) {
      let herramientaCierre = false;
      this.listaDistibucion.forEach((element) => {
        if (element.descuentoCupon != null || element.montoCupon != null) {
          herramientaCierre = true;
        }
      });
      if (accion == 0) {
        this.modalPago = true;
      } else {
        if (herramientaCierre) {
          this.$swal({
            icon: "warning",
            showCancelButton: true,
            title: "Nuevo método de pago por corrección PTI",
            text: "Para agregar un nuevo método de pago tiene que agregarlo desde '\"Corrección método de pago PTI'\", ¿deseas ir a corrección de pago?",
            confirmButtonText: "Corregir pago pti",
            confirmButtonColor: "#FFC300",
            cancelButtonText: "Cancelar",
            cancelButtonColor: "#7B7D7D",
          }).then((result) => {
            if (result.isConfirmed) {
              this.mostrarModalCorregirPTI = true;
            } else {
              return;
            }
          });
        } else {
          this.modalPago = true;
        }
      }
    },
    cerrarModal() {
      this.modalPago = false;
      this.bloquearMonto = false;
      this.tipoPago = 1;
      this.pago = this.newPago();
      this.$v.$reset();
    },
    abrirModalCupon() {
      //validar formas de pago sin plazo fijo
      let tienePF = false;
      this.formaPagoCaja.forEach((element) => {
        if (element.idPagoPlazoFijo != null) {
          tienePF = true;
        }
      });

      if (tienePF) {
        this.$swal({
          icon: "info",
          text: "Por el momento no se pueden redimir cupones con el método de pago plazo fijo.",
          confirmButtonText: "Cerrar",
          confirmButtonColor: "#d3d4d5",
        });
        return;
      }
      this.modalCupon = true;
    },
    aplicarCuponMarketing() {
      //validar formas de pago sin plazo fijo
      let tienePF = false;
      this.formaPagoCaja.forEach((element) => {
        if (
          element.idPagoPlazoFijo !== null ||
          element.idMetodoPago === 7 ||
          element.msi !== null
        ) {
          tienePF = true;
        }
      });

      if (tienePF) {
        this.$swal({
          icon: "info",
          text: "Por el momento no se pueden redimir cupones con el método de pago plazo fijo.",
          confirmButtonText: "Cerrar",
          confirmButtonColor: "#d3d4d5",
        });
        return;
      }
      this.validarTratamientosDisponibles();
      if (this.tratamientosCupon.length > 0) {
        const parametros = {
          codigo: this.codigo,
          idsTratamientos: this.tratamientosCupon,
          idPaciente: this.informacionSesion.idPaciente,
        };
        
        this.$http
          .post(this.$api + "cupon/aplicarMarketing", parametros) //serv aplicar 
          .then((res) => {
            const cupon = res.data.data;
            this.mensaje = cupon.mensaje;
            if (cupon.idTipoAplicacion === 1) {
              
              this.seleccionar(cupon);
            } else if (cupon.idTipoAplicacion === 2) {
              const cm = cupon;
              const ids = [];
              cm.idsTratamientos.forEach((id) => {
                ids.push(id);
              });
              cm.idTratamiento = ids;
              this.seleccionar(cm);
            }

            if (this.mensaje == null) {
              this.cuponActivo = true;
              this.cuponMarketing = true;
            }
          });
      }
    },
    cerrarModalCupon() {
      this.modalCupon = false;
      if (this.cuponActivo == false) {
        this.fieldsDisabled = false;
        this.cuponesDisponibles.forEach((c) => (c.seleccionado = false));
        this.cuponSeleccionado = [];
        this.arregloCupones = [];
      }
      this.$v.$reset();
    },

    filterJustNumber(e) {
      const key = e.key;

      if (key === "-") {
        return e.preventDefault();
      }

      if (key === "+") {
        return e.preventDefault();
      }

      if (key === ".") {
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") {
        return e.preventDefault();
      }
    },

    seleccionar(item) { 
      let bandera = false;
      item.seleccionado = true;
      
      this.arregloCupones.forEach((ac) => {
        if (ac.otraPromo == true) {
          bandera = true;
        } else {
          bandera = false;
        }

      });
      if (bandera == true) {
        this.arregloCupones.push(item);

      } else {
        this.arregloCupones = [];
        this.arregloCupones.push(item);
 
      }
      if (
        this.arregloCupones[this.arregloCupones.length - 1].otraPromo == true
      ) {
        this.cuponSeleccionado = this.arregloCupones.sort();
      } else {
        if (this.cuponSeleccionado.length == 0) {
          this.cuponSeleccionado.push(this.arregloCupones[0]);
        }
        this.fieldsDisabled = true;
      }
  
    },
    aplicarCupon() {
      if (this.total - this.totalCuponesM < 0) {
        this.$swal
          .fire({
            icon: "warning",
            title: "El cupón es mayor al monto total",
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: "#FFC300",
            size: "m",
            text: "Si continúa se aplicará el cupón al monto actual y perderá el restante, ¿Desea continuar?",
          })
          .then((aceptar) => {
            if (aceptar.value) {
              if (this.descuentoCupon > 0) {
                this.cuponActivo = false;
                this.calcularCupones();
              } else {
                this.modalCupon = false;
                this.$v.$reset();
                this.cuponActivo = true;
                this.restante -= this.totalCuponesM;
                if (this.cuponSeleccionado.length > 0) {
                  this.fieldsDisabled = true;
                }
              }
            }
          });
      } else {
        if (this.descuentoCupon > 0) {
          this.cuponConHerramienta = true;
        }
        this.modalCupon = false;
        this.$v.$reset();
        this.cuponActivo = true;
        this.restante -= this.totalCuponesM;
        if (this.cuponSeleccionado.length > 0) {
          this.fieldsDisabled = true;
        }
      }
    },
    calcularDescuentoPorTratamiento() {
      this.numSesiones = 0;
      this.descuentoPorTratamiento = [];
      let index = [];
      let indexKit = [];
      let indexListaTrts = [];
      this.cuponSeleccionado.forEach((c) => {
        if (c.idTratamiento.length > 1) {
          c.idTratamiento.forEach((t) => {
            if (this.listaDistibucion.length > 0) {
              this.listaDistibucion.forEach((ts, i) => {
                if (ts.idKitTratamientos == null) {
                  if (ts.idTratamiento == t) {
                    index.push(i);
                  }
                } else {
                  ts.listaTratamientos.forEach((lt, j) => {
                    if (lt.idTratamiento == t) {
                      indexListaTrts.push(j);
                    }
                  });
                }
              });
            } else {
              this.tratamientosSesion.forEach((ts, i) => {
                if (ts.idKitTratamientos == null) {
                  if (ts.idTratamiento == t && ts.subTotal > 0) {
                    index.push(i);
                  }
                } else {
                  ts.listaTratamientos.forEach((lt, j) => {
                    if (lt.idTratamiento == t) {
                      indexListaTrts.push(j);
                    }
                  });
                }
              });
            }
          });
        } else {
          if (this.listaDistibucion.length > 0) {
            this.listaDistibucion.forEach((ts, i) => {
              if (ts.idKitTratamientos == null) {
                if (
                  ts.idTratamiento == c.idTratamiento &&
                  ts.idPromocion == null
                ) {
                  index.push(i);
                }
              } else {
                ts.listaTratamientos.forEach((lt, j) => {
                  if (
                    lt.idTratamiento == c.idTratamiento &&
                    lt.idPromocion == null
                  ) {
                    indexListaTrts.push(j);
                    if (!indexKit.includes(i)) {
                      indexKit.push(i);
                    }
                  }
                });
              }
            });
          } else {
            this.tratamientosSesion.forEach((ts, i) => {
              if (ts.idKitTratamientos == null) {
                if (
                  ts.idTratamiento == c.idTratamiento &&
                  ts.idPromocion == null &&
                  ts.subTotal > 0
                ) {
                  index.push(i);
                }
              } else {
                ts.listaTratamientos.forEach((lt, j) => {
                  if (
                    lt.idTratamiento == c.idTratamiento &&
                    lt.idPromocion == null
                  ) {
                    indexListaTrts.push(j);
                    if (!indexKit.includes(i)) {
                      indexKit.push(i);
                    }
                  }
                });
              }
            });
          }
        }
      });
      index.sort((a, b) => a - b);
      for (let i = 0; i < index.length; i++) {
        let porcentaje = 0;


        this.cuponSeleccionado.forEach((c) => {
          if (c.idTipoDescuentoCupon == 1) {
 
            if (this.listaDistibucion.length > 0) {
           
              porcentaje =
                (this.listaDistibucion[index[i]].subTotal / 100) *
                c.cantidadDescuento;

            }
            if (this.tratamientosSesion.length > 0) {
              if (this.tratamientosSesion[index[i]].precioSesion > 0) {
                porcentaje =
                  (this.tratamientosSesion[index[i]].precioSesion / 100) *
                  c.cantidadDescuento;
                this.tratamientosSesion[index[i]].cupon =
                  Math.floor(porcentaje);
              }
            }
            this.descuentoPorTratamiento.push(Math.floor(porcentaje));
          } else {
            if (this.listaDistibucion.length > 0) {
              porcentaje = c.cantidadDescuento;
              this.listaDistibucion[index[i]].cupon = Math.floor(porcentaje);

              if (indexKit.length > 0) {
                indexKit.forEach((kit) => {
                  this.listaDistibucion[kit].listaTratamientos.forEach(
                    (lt, index) => {
                      if (indexListaTrts.includes(index)) {
                        lt.cupon = Math.floor(porcentaje);
                      }
                    }
                  );
                });
              }
            }
            if (this.tratamientosSesion.length > 0) {
              let cupon = c.cantidadDescuento;
              porcentaje = c.cantidadDescuento;
              if (this.tratamientosSesion[index[i]].subTotal - porcentaje < 0) {
                if (this.tratamientosSesion[index[i]].subTotal > 0) {
                  this.tratamientosSesion.forEach((ts, pos) => {
                    if (index[i] == pos) {
                      if (ts.subTotal > 0) {
                        if (ts.subTotal - cupon < 0) {
                          porcentaje = ts.subTotal;
                          cupon = Math.abs(ts.subTotal - cupon);
                        } else {
                          porcentaje = c.cantidadDescuento;
                          cupon = 0;
                        }
                      } else {
                        porcentaje = ts.subTotal;
                      }
                    }
                  });
                }
              }
              this.tratamientosSesion[index[i]].cupon = Math.floor(porcentaje);
            }
            this.descuentoPorTratamiento.push(porcentaje);
          }
        });
      }
      if (this.numSesiones == 0) {
        this.numSesiones = 1;
      }
      let descuentoTotal = 0;
      this.descuentoPorTratamiento.forEach((dpt) => {
        descuentoTotal += dpt;
      });
      return descuentoTotal;
    },
    calcularCupones() {
      this.cuponConHerramienta = true;
    },
    boton() {
      if (this.mostrar == true) this.mostrar = false;
      else this.mostrar = true;
    },
    eliminarCupon(index) {
      this.$swal
        .fire({
          icon: "info",
          title: "Aviso",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCancelButton: true,
          showConfirmButton: true,
          text: "¿Desea quitar el cupón?",
        })
        .then((aceptar) => {
          if (aceptar.value) {
            if (this.cuponMarketing === false) {
              if (this.cuponSeleccionado[0].idTipoAplicacion == 2) {
                if (this.cuponSeleccionado.length > 1) {
                  this.cuponesDisponibles[
                    this.cuponesDisponibles.findIndex(
                      (cupon) =>
                        cupon.cantidadDescuento ===
                        this.cuponSeleccionado[index - 1].cantidadDescuento
                    )
                  ].seleccionado = false;
                  this.cuponSeleccionado.splice(0, 1);
                }
                this.cuponesDisponibles[
                  this.cuponesDisponibles.findIndex(
                    (cupon) =>
                      cupon.cantidadDescuento ===
                      this.cuponSeleccionado[0].cantidadDescuento
                  )
                ].seleccionado = false;
                this.cuponSeleccionado.splice(0, 1);
              } else {
                this.cuponesDisponibles[
                  this.cuponesDisponibles.findIndex(
                    (cupon) =>
                      cupon.cantidadDescuento ===
                      this.cuponSeleccionado[0].cantidadDescuento
                  )
                ].seleccionado = false;
                this.cuponSeleccionado.splice(0, 1);
              }
              this.restante =
                this.total - this.totalPagado - this.totalCuponesM;
              this.fieldsDisabled = false;
              this.cuponConHerramienta = false;
            } else {
              this.cuponSeleccionado.splice(0, 1);
              this.fieldsDisabled = false;
              this.cuponActivo = false;
              this.cuponMarketing = false;
              this.codigo = null;
              this.marketing = true;
            }
          }
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.pago[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },

    preguntarCorrecionPTI() {
      this.mostrarModalCorregirPTI = true;
    },
    cancelarRenegociarPTI() {
      this.mostrarModalCorregirPTI = false;
    },
    renegociarPTI(anfition) {
      this.loadRenegociar = true;
      const params = {
        idPaciente: this.informacionSesion.idPaciente,
        idSession: this.idSesion,
      };
      const url = this.$api + "caja/renegociarPTI";

      this.$http
        .put(url, params)
        .then(() => {
          this.loadRenegociar = false;
          this.renegociacionExitosa = true;
          if (anfition) {
            this.iniciarRealizarCorrecionPTIAnfitrion();
          } else {
            this.iniciarRealizarCorrecionPTIEmbajador();
          }
        })
        .catch((error) => {
          this.loadRenegociar = false;
          const message = error.response.data.message
            ? error.response.data.message
            : "Ocurrio un error al querer renegociar el pti, verifica la unidad de presentación";

          this.$swal({
            icon: "error",
            title: message,
            showConfirmButton: false,
          });
        });
    },
    iniciarRealizarCorrecionPTIEmbajador() {
      this.mostrarModalCorregirPTI = false;
      this.$router.push({
        name: "dashboard",
      });
    },
    iniciarRealizarCorrecionPTIAnfitrion() {
      this.mostrarModalCorregirPTI = false;
      this.cambiarActivarEdicionAnfitrion(true);
    },
    cambiarActivarEdicionAnfitrion(activar) {
      this.activarEdicionAnfitrion = activar;
    },
    verificarFinCargaInicial(position) {
      if (this.idRecibo !== null) {
        this.finalizoCargaInicial.finalizado = true;
      } else {
        this.finalizoCargaInicial.fin[position] = true;

        if (!this.finalizoCargaInicial.finalizado) {
          const cargando = this.finalizoCargaInicial.fin.some(
            (it) => it === false
          );
          if (!cargando) {
            this.finalizoCargaInicial.finalizado = true;
            if (this.$route.name === "cajaSesionRenegociar") {
              this.renegociarPTI(true);
            }
          }
        }
      }
    },
    obtenerSaldoVale() {
      let idPlan = null;
      this.tratamientosSesion.forEach((ts) => {
        if (ts.idPlan != null) {
          idPlan = ts.idPlan;
        }
      });
      if (idPlan == null) {
        this.listaDistibucion.forEach((ld) => {
          if (ld.idPlan != null) {
            idPlan = ld.idPlan;
          }
        });
      }
      if (idPlan != null) {
        this.loaderInformacion = true;
        this.nuevoM2Service
          .obtenerDatosVale(idPlan, this.informacionSesion.idPaciente)
          .then((r) => {
            this.loaderInformacion = false;
            if (r != null) {
              this.vale = r.saldoActual;
            }
          })
          .catch((err) => {
            console.error(err);
            this.loaderInformacion = false;
          });
      }
    },
    verificarBloqueo() {
      this.saldoBloqueado = false;
      this.$http
        .post(this.$api + "ws/reembolsos/existeReembolsoProceso", {
          idPaciente: this.informacionSesion.idPaciente,
        })
        .then((response) => {
          this.saldoBloqueado = response.data.success;
        });
    },

    bloquearAccionesTratamientosSesion(){
      let body = {
        idSesion: this.idSesion
      }
      this.$http.post(this.$api + "lock/block_caja", body)
          .then((response) => {
            const fechaFin = response.data.data.fechaFinBloqueo;
            const endTime = new Date(fechaFin).getTime();
            const now = Date.now();
            const ms = Math.max(0, endTime - now);

            // Programar bloqueo cuando llegue la fecha fin
            this.timerId = setTimeout(() => {
              this.regresarPantalla();
            }, ms);
          });

    },

    async desbloquearSesion() {
      const { data } = await this.$http.post(
          this.$api + "lock/desbloquear/sesion",
          { idSesion: this.idSesion }
      );
      return data;
    },
  },
};
</script>

<style scoped>
p{
  margin: 0px;
}
.card-caja {
  background: #f6f6f6;
  border: none;
}

.datitos {
  font-size: small;
  padding: 0;
  margin: 0;
  color: lightslategray;
}

.datitosblack {
  font-size: small;
  padding: 0;
  margin: 0;
}

.datitos > p {
  margin-bottom: 0.5rem;
}

.datosPago {
  font-size: medium;
  padding: 0;
  margin: 0;
  color: lightslategray;
}

.txSesion > .card-body {
  padding: 0.5rem;
}
.txSesion {
  border-radius: 10px;
  border-color: #17a2b8;
}

.titulo {
  font-size: large;
}
</style>
